// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: robot_syncer/plant_profile.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Formula } from "../almanac/almanac";
import { Empty } from "../google/protobuf/empty";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "carbon.robot_syncer.plant_profile";

/**
 * Mirrors carbon.frontend.category_profile.ShootBehavior.
 * Deprecated: plant-profile membership discriminators are no longer stored.
 *
 * @deprecated
 */
export enum ShootBehavior {
  SHOOT_BEHAVIOR_UNSPECIFIED = 0,
  DONT_SHOOT = 1,
  SHOOT_OPPORTUNISTICALLY = 2,
  SHOOT = 3,
  UNRECOGNIZED = -1,
}

export function shootBehaviorFromJSON(object: any): ShootBehavior {
  switch (object) {
    case 0:
    case "SHOOT_BEHAVIOR_UNSPECIFIED":
      return ShootBehavior.SHOOT_BEHAVIOR_UNSPECIFIED;
    case 1:
    case "DONT_SHOOT":
      return ShootBehavior.DONT_SHOOT;
    case 2:
    case "SHOOT_OPPORTUNISTICALLY":
      return ShootBehavior.SHOOT_OPPORTUNISTICALLY;
    case 3:
    case "SHOOT":
      return ShootBehavior.SHOOT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ShootBehavior.UNRECOGNIZED;
  }
}

export function shootBehaviorToJSON(object: ShootBehavior): string {
  switch (object) {
    case ShootBehavior.SHOOT_BEHAVIOR_UNSPECIFIED:
      return "SHOOT_BEHAVIOR_UNSPECIFIED";
    case ShootBehavior.DONT_SHOOT:
      return "DONT_SHOOT";
    case ShootBehavior.SHOOT_OPPORTUNISTICALLY:
      return "SHOOT_OPPORTUNISTICALLY";
    case ShootBehavior.SHOOT:
      return "SHOOT";
    case ShootBehavior.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Role {
  ROLE_UNSPECIFIED = 0,
  CROP = 1,
  WEED = 2,
  BENEFICIAL = 3,
  DISREGARD = 4,
  UNRECOGNIZED = -1,
}

export function roleFromJSON(object: any): Role {
  switch (object) {
    case 0:
    case "ROLE_UNSPECIFIED":
      return Role.ROLE_UNSPECIFIED;
    case 1:
    case "CROP":
      return Role.CROP;
    case 2:
    case "WEED":
      return Role.WEED;
    case 3:
    case "BENEFICIAL":
      return Role.BENEFICIAL;
    case 4:
    case "DISREGARD":
      return Role.DISREGARD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Role.UNRECOGNIZED;
  }
}

export function roleToJSON(object: Role): string {
  switch (object) {
    case Role.ROLE_UNSPECIFIED:
      return "ROLE_UNSPECIFIED";
    case Role.CROP:
      return "CROP";
    case Role.WEED:
      return "WEED";
    case Role.BENEFICIAL:
      return "BENEFICIAL";
    case Role.DISREGARD:
      return "DISREGARD";
    case Role.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface BaseVersionMetadata {
  /** client generated version guid */
  versionId: string;
  /** ideally auth0 id, but can be robot name */
  userId: string;
  /** the time that the client recorded the change */
  clientVersionCreateTime: string | undefined;
}

export interface AddVersionMetadata {
  versionId: string;
  /** ideally auth0 id, but can be robot name */
  userId: string;
  /** the time that the client recorded the change */
  clientVersionCreateTime:
    | string
    | undefined;
  /** version uuid - the version the client knew */
  parentVersionId: string;
  /** about when creating this version */
  active: boolean;
  /** the last active_version (head) reported by the server that this */
  lastKnownActiveVersionId?: string | undefined;
}

export interface SavedVersionMetadata {
  /** uuid */
  versionId: string;
  /** ideally auth0 id, but can be robot name */
  userId: string;
  /** the time that the client recorded the change */
  clientVersionCreateTime:
    | string
    | undefined;
  /** nullable version uuid - the version the client knew about when */
  parentVersionId?:
    | string
    | undefined;
  /** creating this version */
  revertVersionId?:
    | string
    | undefined;
  /** nullable - the time that the client recorded deletion - will always */
  clientDeleteTime?:
    | string
    | undefined;
  /** be set if deleted_by is set -- db or client? */
  deletedBy?:
    | string
    | undefined;
  /** when the version was activated */
  activeTime?:
    | string
    | undefined;
  /** monotonic id of the change (transaction) that created this version. */
  changeId: number;
}

/** Mirrors carbon.frontend.category_profile.CategoryAlmanac. */
export interface Almanac {
  /** Size range boundaries in mm. N boundaries define N+1 ranges. */
  sizeBoundariesMm: number[];
  /**
   * Shoot-time formula per size range; len(formulas) == len(size_boundaries_mm)
   * + 1.
   */
  formulas: Formula[];
  /**
   * Legacy almanac category these shoot times were seeded from: the point
   * category uuid of Broadleaf, Grass, Offshoot or Purslane, else "DEFAULT".
   */
  originCategoryId: string;
}

/**
 * Mirrors carbon.frontend.category_profile.CategoryDiscriminator.
 * Deprecated: plant-profile membership discriminators are no longer stored.
 *
 * @deprecated
 */
export interface Discriminator {
  behaviors: ShootBehavior[];
}

export interface Category {
  customerId?:
    | string
    | undefined;
  /** empty object indicates presence */
  carbon?:
    | Empty
    | undefined;
  /** profile data */
  id: string;
  name: string;
  /** veselka prediction point ids */
  chipIds: string[];
  almanac?: Almanac | undefined;
}

export interface LibraryMetadata {
  addedTime: string | undefined;
  addedBy: string;
}

export interface SavedCategory {
  metadata: SavedVersionMetadata | undefined;
  category: Category | undefined;
  libraryMetadata?: LibraryMetadata | undefined;
}

export interface IdPair {
  /** uuid of the entity */
  id: string;
  /** uuid of the specific version of that entity */
  versionId: string;
  /** role of this category within a collection */
  role?:
    | Role
    | undefined;
  /**
   * Deprecated: no longer stored. Clients may still send this; it is ignored.
   *
   * @deprecated
   */
  discriminator?: Discriminator | undefined;
}

export interface CategoryCollection {
  customerId?:
    | string
    | undefined;
  /** empty object indicates presence */
  carbon?:
    | Empty
    | undefined;
  /** uuid */
  id: string;
  name: string;
  categoryIds: IdPair[];
}

export interface SavedCategoryCollection {
  metadata: SavedVersionMetadata | undefined;
  collection: CategoryCollection | undefined;
}

export interface PlantProfile {
  customerId?:
    | string
    | undefined;
  /** empty object indicates presence */
  carbon?:
    | Empty
    | undefined;
  /** uuid */
  id: string;
  name: string;
  categories: SavedCategory[];
  categoryMemberships: IdPair[];
}

export interface SavedPlantProfile {
  metadata: SavedVersionMetadata | undefined;
  profile: PlantProfile | undefined;
}

export interface TextSearch {
  query: string;
}

export interface ProfileFilters {
  customerId?:
    | string
    | undefined;
  /** empty object indicates presence */
  carbon?: Empty | undefined;
  search?: TextSearch | undefined;
}

/** cursor based pagination params */
export interface PaginationRequest {
  limit: number;
  /** cursor that pages toward newer items */
  newer?:
    | string
    | undefined;
  /** cursor that pages toward older items */
  older?: string | undefined;
  asOf?: string | undefined;
}

export interface PaginationResponse {
  /** Presence implies availability of next page. Return BOTH when in the middle. */
  nextOld?:
    | string
    | undefined;
  /** pass as PaginationRequest.newer for more results */
  nextNew?: string | undefined;
  asOf?: string | undefined;
}

export interface RevertProfile {
  /** entity uuid - either Category or Plant Profile */
  id: string;
  /** version uuid - a previous version that we want to revert to */
  revertVersionId: string;
}

export interface ListCategoriesRequest {
  filters: ProfileFilters | undefined;
  pagination: PaginationRequest | undefined;
  inLibrary?: boolean | undefined;
  includeCustomCategories: boolean;
}

export interface ListCategoriesResponse {
  categories: SavedCategory[];
  pagination: PaginationResponse | undefined;
}

export interface GetCategoryRequest {
  /** uuid */
  id: string;
  /**
   * If true, return the category even if its latest version is deleted
   * (e.g. to resolve display names for historical metrics).
   */
  includeDeleted: boolean;
}

/** @deprecated */
export interface CreateCategoryRequest {
  metadata: BaseVersionMetadata | undefined;
  category: Category | undefined;
}

/** @deprecated */
export interface AddCategoryVersionRequest {
  metadata: AddVersionMetadata | undefined;
  category?: Category | undefined;
  revert?: RevertProfile | undefined;
}

/** @deprecated */
export interface DeleteCategoryRequest {
  metadata:
    | BaseVersionMetadata
    | undefined;
  /** uuid */
  id: string;
}

export interface DeleteCategoryResponse {
}

export interface ListCategoryCollectionsRequest {
  filters: ProfileFilters | undefined;
  pagination: PaginationRequest | undefined;
  includeCustomCategories: boolean;
}

export interface ListCategoryCollectionsResponse {
  collections: SavedCategoryCollection[];
  pagination: PaginationResponse | undefined;
}

export interface GetCategoryCollectionRequest {
  /** uuid */
  id: string;
}

export interface SetCategoryCollectionVersionActiveRequest {
  /** ideally auth0 id, but can be robot name */
  userId: string;
  /** uuid */
  id: string;
  /** uuid */
  versionId: string;
  /** the last active_version (head) reported by the server that this */
  lastKnownActiveVersionId?: string | undefined;
}

export interface SetCategoryCollectionVersionActiveResponse {
}

export interface SetCategoryVersionActiveRequest {
  /** ideally auth0 id, but can be robot name */
  userId: string;
  /** uuid */
  id: string;
  /** uuid */
  versionId: string;
  /** the last active_version (head) reported by the server that this */
  lastKnownActiveVersionId?: string | undefined;
}

export interface SetCategoryVersionActiveResponse {
}

export interface ListPlantProfilesRequest {
  filters: ProfileFilters | undefined;
  pagination: PaginationRequest | undefined;
  includeCustomCategories: boolean;
}

export interface ListPlantProfilesResponse {
  plantProfiles: SavedPlantProfile[];
  pagination: PaginationResponse | undefined;
}

export interface GetPlantProfileRequest {
  /** uuid */
  id: string;
}

export interface BaseTransactionMetadata {
  /** ideally auth0 id, but can be robot name */
  userId: string;
  /** the time that the client recorded the change */
  clientVersionCreateTime: string | undefined;
}

export interface CreateMetadataInTransaction {
  versionId: string;
}

export interface AddVersionMetadataInTransaction {
  versionId: string;
  /** version uuid - the version the client knew */
  parentVersionId: string;
  /** about when creating this version */
  active: boolean;
  /** the last active_version (head) reported by the server that this */
  lastKnownActiveVersionId?: string | undefined;
}

export interface DeleteMetadataInTransaction {
  parentVersionId: string;
  active: boolean;
  lastKnownActiveVersionId?: string | undefined;
}

export interface CreateCategoryInTransaction {
  metadata: CreateMetadataInTransaction | undefined;
  category: Category | undefined;
  library?: boolean | undefined;
}

export interface AddCategoryVersionInTransaction {
  metadata: AddVersionMetadataInTransaction | undefined;
  category?: Category | undefined;
  revert?: RevertProfile | undefined;
}

export interface DeleteCategoryInTransaction {
  /** uuid */
  id: string;
  /**
   * robots <2.5 don't support versioned category deletes, so deletes are always
   * active and affect the active category version.
   */
  metadata?: DeleteMetadataInTransaction | undefined;
}

export interface CategoryChange {
  create?: CreateCategoryInTransaction | undefined;
  update?: AddCategoryVersionInTransaction | undefined;
  delete?: DeleteCategoryInTransaction | undefined;
}

export interface CreateCategoryCollectionInTransaction {
  metadata: CreateMetadataInTransaction | undefined;
  collection: CategoryCollection | undefined;
}

export interface AddCategoryCollectionVersionInTransaction {
  metadata: AddVersionMetadataInTransaction | undefined;
  collection?: CategoryCollection | undefined;
  revert?: RevertProfile | undefined;
}

export interface DeleteCategoryCollectionInTransaction {
  /** uuid */
  id: string;
}

export interface CategoryCollectionChange {
  create?: CreateCategoryCollectionInTransaction | undefined;
  update?: AddCategoryCollectionVersionInTransaction | undefined;
  delete?: DeleteCategoryCollectionInTransaction | undefined;
}

export interface ApplyPlantProfileTransactionRequest {
  metadata: BaseTransactionMetadata | undefined;
  categories: CategoryChange[];
  collections: CategoryCollectionChange[];
}

export interface ApplyPlantProfileTransactionResponse {
  categories: SavedCategory[];
  collections: SavedCategoryCollection[];
}

export interface ListCategoryCollectionHistoryRequest {
  /** uuid */
  id: string;
  pagination: PaginationRequest | undefined;
}

export interface ListCategoryCollectionHistoryResponse {
  pagination: PaginationResponse | undefined;
  versions: SavedVersionMetadata[];
}

export interface ListCategoryHistoryRequest {
  /** category uuid */
  id: string;
  pagination: PaginationRequest | undefined;
}

export interface ListCategoryHistoryResponse {
  pagination: PaginationResponse | undefined;
  versions: SavedVersionMetadata[];
}

export interface GetPlantProfileVersionRequest {
  id: string;
  versionId: string;
}

export interface GetCategoryVersionRequest {
  id: string;
  versionId: string;
}

export interface GetCategoriesRequest {
  categories: GetCategoriesRequest_IdPair[];
}

export interface GetCategoriesRequest_IdPair {
  id: string;
  versionId?: string | undefined;
}

export interface GetCategoriesResponse {
  categories: { [key: string]: SavedCategory };
}

export interface GetCategoriesResponse_CategoriesEntry {
  key: string;
  value: SavedCategory | undefined;
}

export interface GetCategoryIdsForCategoryCollectionsRequest {
  collections: GetCategoryIdsForCategoryCollectionsRequest_IdPair[];
}

export interface GetCategoryIdsForCategoryCollectionsRequest_IdPair {
  id: string;
  versionId?: string | undefined;
}

export interface GetCategoryIdsForCategoryCollectionsResponse {
  /** keyed by collection id */
  collections: { [key: string]: GetCategoryIdsForCategoryCollectionsResponse_Versions };
}

export interface GetCategoryIdsForCategoryCollectionsResponse_IdPair {
  id: string;
  versionId: string;
}

export interface GetCategoryIdsForCategoryCollectionsResponse_IdPairs {
  categoryIds: GetCategoryIdsForCategoryCollectionsResponse_IdPair[];
}

export interface GetCategoryIdsForCategoryCollectionsResponse_Versions {
  /** keyed by collection version id */
  versions: { [key: string]: GetCategoryIdsForCategoryCollectionsResponse_IdPairs };
}

export interface GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry {
  key: string;
  value: GetCategoryIdsForCategoryCollectionsResponse_IdPairs | undefined;
}

export interface GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry {
  key: string;
  value: GetCategoryIdsForCategoryCollectionsResponse_Versions | undefined;
}

export interface GetCategoryCollectionsRequest {
  collections: GetCategoryCollectionsRequest_IdPair[];
}

export interface GetCategoryCollectionsRequest_IdPair {
  id: string;
  versionId?: string | undefined;
}

export interface GetCategoryCollectionsResponse {
  collections: { [key: string]: SavedCategoryCollection };
}

export interface GetCategoryCollectionsResponse_CollectionsEntry {
  key: string;
  value: SavedCategoryCollection | undefined;
}

function createBaseBaseVersionMetadata(): BaseVersionMetadata {
  return { versionId: "", userId: "", clientVersionCreateTime: undefined };
}

export const BaseVersionMetadata: MessageFns<BaseVersionMetadata> = {
  encode(message: BaseVersionMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.versionId !== "") {
      writer.uint32(10).string(message.versionId);
    }
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    if (message.clientVersionCreateTime !== undefined) {
      Timestamp.encode(toTimestamp(message.clientVersionCreateTime), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BaseVersionMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBaseVersionMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.clientVersionCreateTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BaseVersionMetadata {
    return {
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : "",
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      clientVersionCreateTime: isSet(object.clientVersionCreateTime)
        ? globalThis.String(object.clientVersionCreateTime)
        : isSet(object.client_version_create_time)
        ? globalThis.String(object.client_version_create_time)
        : undefined,
    };
  },

  toJSON(message: BaseVersionMetadata): unknown {
    const obj: any = {};
    if (message.versionId !== "") {
      obj.versionId = message.versionId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.clientVersionCreateTime !== undefined) {
      obj.clientVersionCreateTime = message.clientVersionCreateTime;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BaseVersionMetadata>, I>>(base?: I): BaseVersionMetadata {
    return BaseVersionMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BaseVersionMetadata>, I>>(object: I): BaseVersionMetadata {
    const message = createBaseBaseVersionMetadata();
    message.versionId = object.versionId ?? "";
    message.userId = object.userId ?? "";
    message.clientVersionCreateTime = object.clientVersionCreateTime ?? undefined;
    return message;
  },
};

function createBaseAddVersionMetadata(): AddVersionMetadata {
  return {
    versionId: "",
    userId: "",
    clientVersionCreateTime: undefined,
    parentVersionId: "",
    active: false,
    lastKnownActiveVersionId: undefined,
  };
}

export const AddVersionMetadata: MessageFns<AddVersionMetadata> = {
  encode(message: AddVersionMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.versionId !== "") {
      writer.uint32(10).string(message.versionId);
    }
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    if (message.clientVersionCreateTime !== undefined) {
      Timestamp.encode(toTimestamp(message.clientVersionCreateTime), writer.uint32(26).fork()).join();
    }
    if (message.parentVersionId !== "") {
      writer.uint32(34).string(message.parentVersionId);
    }
    if (message.active !== false) {
      writer.uint32(40).bool(message.active);
    }
    if (message.lastKnownActiveVersionId !== undefined) {
      writer.uint32(50).string(message.lastKnownActiveVersionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddVersionMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddVersionMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.clientVersionCreateTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parentVersionId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.lastKnownActiveVersionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddVersionMetadata {
    return {
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : "",
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      clientVersionCreateTime: isSet(object.clientVersionCreateTime)
        ? globalThis.String(object.clientVersionCreateTime)
        : isSet(object.client_version_create_time)
        ? globalThis.String(object.client_version_create_time)
        : undefined,
      parentVersionId: isSet(object.parentVersionId)
        ? globalThis.String(object.parentVersionId)
        : isSet(object.parent_version_id)
        ? globalThis.String(object.parent_version_id)
        : "",
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      lastKnownActiveVersionId: isSet(object.lastKnownActiveVersionId)
        ? globalThis.String(object.lastKnownActiveVersionId)
        : isSet(object.last_known_active_version_id)
        ? globalThis.String(object.last_known_active_version_id)
        : undefined,
    };
  },

  toJSON(message: AddVersionMetadata): unknown {
    const obj: any = {};
    if (message.versionId !== "") {
      obj.versionId = message.versionId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.clientVersionCreateTime !== undefined) {
      obj.clientVersionCreateTime = message.clientVersionCreateTime;
    }
    if (message.parentVersionId !== "") {
      obj.parentVersionId = message.parentVersionId;
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.lastKnownActiveVersionId !== undefined) {
      obj.lastKnownActiveVersionId = message.lastKnownActiveVersionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddVersionMetadata>, I>>(base?: I): AddVersionMetadata {
    return AddVersionMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddVersionMetadata>, I>>(object: I): AddVersionMetadata {
    const message = createBaseAddVersionMetadata();
    message.versionId = object.versionId ?? "";
    message.userId = object.userId ?? "";
    message.clientVersionCreateTime = object.clientVersionCreateTime ?? undefined;
    message.parentVersionId = object.parentVersionId ?? "";
    message.active = object.active ?? false;
    message.lastKnownActiveVersionId = object.lastKnownActiveVersionId ?? undefined;
    return message;
  },
};

function createBaseSavedVersionMetadata(): SavedVersionMetadata {
  return {
    versionId: "",
    userId: "",
    clientVersionCreateTime: undefined,
    parentVersionId: undefined,
    revertVersionId: undefined,
    clientDeleteTime: undefined,
    deletedBy: undefined,
    activeTime: undefined,
    changeId: 0,
  };
}

export const SavedVersionMetadata: MessageFns<SavedVersionMetadata> = {
  encode(message: SavedVersionMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.versionId !== "") {
      writer.uint32(10).string(message.versionId);
    }
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    if (message.clientVersionCreateTime !== undefined) {
      Timestamp.encode(toTimestamp(message.clientVersionCreateTime), writer.uint32(26).fork()).join();
    }
    if (message.parentVersionId !== undefined) {
      writer.uint32(34).string(message.parentVersionId);
    }
    if (message.revertVersionId !== undefined) {
      writer.uint32(42).string(message.revertVersionId);
    }
    if (message.clientDeleteTime !== undefined) {
      Timestamp.encode(toTimestamp(message.clientDeleteTime), writer.uint32(50).fork()).join();
    }
    if (message.deletedBy !== undefined) {
      writer.uint32(58).string(message.deletedBy);
    }
    if (message.activeTime !== undefined) {
      Timestamp.encode(toTimestamp(message.activeTime), writer.uint32(66).fork()).join();
    }
    if (message.changeId !== 0) {
      writer.uint32(72).int64(message.changeId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SavedVersionMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSavedVersionMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.clientVersionCreateTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.parentVersionId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.revertVersionId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.clientDeleteTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.deletedBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.activeTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.changeId = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SavedVersionMetadata {
    return {
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : "",
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      clientVersionCreateTime: isSet(object.clientVersionCreateTime)
        ? globalThis.String(object.clientVersionCreateTime)
        : isSet(object.client_version_create_time)
        ? globalThis.String(object.client_version_create_time)
        : undefined,
      parentVersionId: isSet(object.parentVersionId)
        ? globalThis.String(object.parentVersionId)
        : isSet(object.parent_version_id)
        ? globalThis.String(object.parent_version_id)
        : undefined,
      revertVersionId: isSet(object.revertVersionId)
        ? globalThis.String(object.revertVersionId)
        : isSet(object.revert_version_id)
        ? globalThis.String(object.revert_version_id)
        : undefined,
      clientDeleteTime: isSet(object.clientDeleteTime)
        ? globalThis.String(object.clientDeleteTime)
        : isSet(object.client_delete_time)
        ? globalThis.String(object.client_delete_time)
        : undefined,
      deletedBy: isSet(object.deletedBy)
        ? globalThis.String(object.deletedBy)
        : isSet(object.deleted_by)
        ? globalThis.String(object.deleted_by)
        : undefined,
      activeTime: isSet(object.activeTime)
        ? globalThis.String(object.activeTime)
        : isSet(object.active_time)
        ? globalThis.String(object.active_time)
        : undefined,
      changeId: isSet(object.changeId)
        ? globalThis.Number(object.changeId)
        : isSet(object.change_id)
        ? globalThis.Number(object.change_id)
        : 0,
    };
  },

  toJSON(message: SavedVersionMetadata): unknown {
    const obj: any = {};
    if (message.versionId !== "") {
      obj.versionId = message.versionId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.clientVersionCreateTime !== undefined) {
      obj.clientVersionCreateTime = message.clientVersionCreateTime;
    }
    if (message.parentVersionId !== undefined) {
      obj.parentVersionId = message.parentVersionId;
    }
    if (message.revertVersionId !== undefined) {
      obj.revertVersionId = message.revertVersionId;
    }
    if (message.clientDeleteTime !== undefined) {
      obj.clientDeleteTime = message.clientDeleteTime;
    }
    if (message.deletedBy !== undefined) {
      obj.deletedBy = message.deletedBy;
    }
    if (message.activeTime !== undefined) {
      obj.activeTime = message.activeTime;
    }
    if (message.changeId !== 0) {
      obj.changeId = Math.round(message.changeId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SavedVersionMetadata>, I>>(base?: I): SavedVersionMetadata {
    return SavedVersionMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SavedVersionMetadata>, I>>(object: I): SavedVersionMetadata {
    const message = createBaseSavedVersionMetadata();
    message.versionId = object.versionId ?? "";
    message.userId = object.userId ?? "";
    message.clientVersionCreateTime = object.clientVersionCreateTime ?? undefined;
    message.parentVersionId = object.parentVersionId ?? undefined;
    message.revertVersionId = object.revertVersionId ?? undefined;
    message.clientDeleteTime = object.clientDeleteTime ?? undefined;
    message.deletedBy = object.deletedBy ?? undefined;
    message.activeTime = object.activeTime ?? undefined;
    message.changeId = object.changeId ?? 0;
    return message;
  },
};

function createBaseAlmanac(): Almanac {
  return { sizeBoundariesMm: [], formulas: [], originCategoryId: "" };
}

export const Almanac: MessageFns<Almanac> = {
  encode(message: Almanac, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.sizeBoundariesMm) {
      writer.float(v);
    }
    writer.join();
    for (const v of message.formulas) {
      Formula.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.originCategoryId !== "") {
      writer.uint32(26).string(message.originCategoryId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Almanac {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAlmanac();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 13) {
            message.sizeBoundariesMm.push(reader.float());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.sizeBoundariesMm.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.formulas.push(Formula.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.originCategoryId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Almanac {
    return {
      sizeBoundariesMm: globalThis.Array.isArray(object?.sizeBoundariesMm)
        ? object.sizeBoundariesMm.map((e: any) => globalThis.Number(e))
        : globalThis.Array.isArray(object?.size_boundaries_mm)
        ? object.size_boundaries_mm.map((e: any) => globalThis.Number(e))
        : [],
      formulas: globalThis.Array.isArray(object?.formulas) ? object.formulas.map((e: any) => Formula.fromJSON(e)) : [],
      originCategoryId: isSet(object.originCategoryId)
        ? globalThis.String(object.originCategoryId)
        : isSet(object.origin_category_id)
        ? globalThis.String(object.origin_category_id)
        : "",
    };
  },

  toJSON(message: Almanac): unknown {
    const obj: any = {};
    if (message.sizeBoundariesMm?.length) {
      obj.sizeBoundariesMm = message.sizeBoundariesMm;
    }
    if (message.formulas?.length) {
      obj.formulas = message.formulas.map((e) => Formula.toJSON(e));
    }
    if (message.originCategoryId !== "") {
      obj.originCategoryId = message.originCategoryId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Almanac>, I>>(base?: I): Almanac {
    return Almanac.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Almanac>, I>>(object: I): Almanac {
    const message = createBaseAlmanac();
    message.sizeBoundariesMm = object.sizeBoundariesMm?.map((e) => e) || [];
    message.formulas = object.formulas?.map((e) => Formula.fromPartial(e)) || [];
    message.originCategoryId = object.originCategoryId ?? "";
    return message;
  },
};

function createBaseDiscriminator(): Discriminator {
  return { behaviors: [] };
}

export const Discriminator: MessageFns<Discriminator> = {
  encode(message: Discriminator, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.behaviors) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Discriminator {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiscriminator();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.behaviors.push(reader.int32() as any);

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.behaviors.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Discriminator {
    return {
      behaviors: globalThis.Array.isArray(object?.behaviors)
        ? object.behaviors.map((e: any) => shootBehaviorFromJSON(e))
        : [],
    };
  },

  toJSON(message: Discriminator): unknown {
    const obj: any = {};
    if (message.behaviors?.length) {
      obj.behaviors = message.behaviors.map((e) => shootBehaviorToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Discriminator>, I>>(base?: I): Discriminator {
    return Discriminator.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Discriminator>, I>>(object: I): Discriminator {
    const message = createBaseDiscriminator();
    message.behaviors = object.behaviors?.map((e) => e) || [];
    return message;
  },
};

function createBaseCategory(): Category {
  return { customerId: undefined, carbon: undefined, id: "", name: "", chipIds: [], almanac: undefined };
}

export const Category: MessageFns<Category> = {
  encode(message: Category, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.customerId !== undefined) {
      writer.uint32(10).string(message.customerId);
    }
    if (message.carbon !== undefined) {
      Empty.encode(message.carbon, writer.uint32(18).fork()).join();
    }
    if (message.id !== "") {
      writer.uint32(26).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    for (const v of message.chipIds) {
      writer.uint32(42).string(v!);
    }
    if (message.almanac !== undefined) {
      Almanac.encode(message.almanac, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Category {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCategory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.carbon = Empty.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.chipIds.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.almanac = Almanac.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Category {
    return {
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : undefined,
      carbon: isSet(object.carbon) ? Empty.fromJSON(object.carbon) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      chipIds: globalThis.Array.isArray(object?.chipIds)
        ? object.chipIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.chip_ids)
        ? object.chip_ids.map((e: any) => globalThis.String(e))
        : [],
      almanac: isSet(object.almanac) ? Almanac.fromJSON(object.almanac) : undefined,
    };
  },

  toJSON(message: Category): unknown {
    const obj: any = {};
    if (message.customerId !== undefined) {
      obj.customerId = message.customerId;
    }
    if (message.carbon !== undefined) {
      obj.carbon = Empty.toJSON(message.carbon);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.chipIds?.length) {
      obj.chipIds = message.chipIds;
    }
    if (message.almanac !== undefined) {
      obj.almanac = Almanac.toJSON(message.almanac);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Category>, I>>(base?: I): Category {
    return Category.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Category>, I>>(object: I): Category {
    const message = createBaseCategory();
    message.customerId = object.customerId ?? undefined;
    message.carbon = (object.carbon !== undefined && object.carbon !== null)
      ? Empty.fromPartial(object.carbon)
      : undefined;
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.chipIds = object.chipIds?.map((e) => e) || [];
    message.almanac = (object.almanac !== undefined && object.almanac !== null)
      ? Almanac.fromPartial(object.almanac)
      : undefined;
    return message;
  },
};

function createBaseLibraryMetadata(): LibraryMetadata {
  return { addedTime: undefined, addedBy: "" };
}

export const LibraryMetadata: MessageFns<LibraryMetadata> = {
  encode(message: LibraryMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.addedTime !== undefined) {
      Timestamp.encode(toTimestamp(message.addedTime), writer.uint32(10).fork()).join();
    }
    if (message.addedBy !== "") {
      writer.uint32(18).string(message.addedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LibraryMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLibraryMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.addedTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.addedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LibraryMetadata {
    return {
      addedTime: isSet(object.addedTime)
        ? globalThis.String(object.addedTime)
        : isSet(object.added_time)
        ? globalThis.String(object.added_time)
        : undefined,
      addedBy: isSet(object.addedBy)
        ? globalThis.String(object.addedBy)
        : isSet(object.added_by)
        ? globalThis.String(object.added_by)
        : "",
    };
  },

  toJSON(message: LibraryMetadata): unknown {
    const obj: any = {};
    if (message.addedTime !== undefined) {
      obj.addedTime = message.addedTime;
    }
    if (message.addedBy !== "") {
      obj.addedBy = message.addedBy;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LibraryMetadata>, I>>(base?: I): LibraryMetadata {
    return LibraryMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LibraryMetadata>, I>>(object: I): LibraryMetadata {
    const message = createBaseLibraryMetadata();
    message.addedTime = object.addedTime ?? undefined;
    message.addedBy = object.addedBy ?? "";
    return message;
  },
};

function createBaseSavedCategory(): SavedCategory {
  return { metadata: undefined, category: undefined, libraryMetadata: undefined };
}

export const SavedCategory: MessageFns<SavedCategory> = {
  encode(message: SavedCategory, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      SavedVersionMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.category !== undefined) {
      Category.encode(message.category, writer.uint32(18).fork()).join();
    }
    if (message.libraryMetadata !== undefined) {
      LibraryMetadata.encode(message.libraryMetadata, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SavedCategory {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSavedCategory();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = SavedVersionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.category = Category.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.libraryMetadata = LibraryMetadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SavedCategory {
    return {
      metadata: isSet(object.metadata) ? SavedVersionMetadata.fromJSON(object.metadata) : undefined,
      category: isSet(object.category) ? Category.fromJSON(object.category) : undefined,
      libraryMetadata: isSet(object.libraryMetadata)
        ? LibraryMetadata.fromJSON(object.libraryMetadata)
        : isSet(object.library_metadata)
        ? LibraryMetadata.fromJSON(object.library_metadata)
        : undefined,
    };
  },

  toJSON(message: SavedCategory): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = SavedVersionMetadata.toJSON(message.metadata);
    }
    if (message.category !== undefined) {
      obj.category = Category.toJSON(message.category);
    }
    if (message.libraryMetadata !== undefined) {
      obj.libraryMetadata = LibraryMetadata.toJSON(message.libraryMetadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SavedCategory>, I>>(base?: I): SavedCategory {
    return SavedCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SavedCategory>, I>>(object: I): SavedCategory {
    const message = createBaseSavedCategory();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? SavedVersionMetadata.fromPartial(object.metadata)
      : undefined;
    message.category = (object.category !== undefined && object.category !== null)
      ? Category.fromPartial(object.category)
      : undefined;
    message.libraryMetadata = (object.libraryMetadata !== undefined && object.libraryMetadata !== null)
      ? LibraryMetadata.fromPartial(object.libraryMetadata)
      : undefined;
    return message;
  },
};

function createBaseIdPair(): IdPair {
  return { id: "", versionId: "", role: undefined, discriminator: undefined };
}

export const IdPair: MessageFns<IdPair> = {
  encode(message: IdPair, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.versionId !== "") {
      writer.uint32(18).string(message.versionId);
    }
    if (message.role !== undefined) {
      writer.uint32(24).int32(message.role);
    }
    if (message.discriminator !== undefined) {
      Discriminator.encode(message.discriminator, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IdPair {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIdPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.discriminator = Discriminator.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IdPair {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : "",
      role: isSet(object.role) ? roleFromJSON(object.role) : undefined,
      discriminator: isSet(object.discriminator) ? Discriminator.fromJSON(object.discriminator) : undefined,
    };
  },

  toJSON(message: IdPair): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.versionId !== "") {
      obj.versionId = message.versionId;
    }
    if (message.role !== undefined) {
      obj.role = roleToJSON(message.role);
    }
    if (message.discriminator !== undefined) {
      obj.discriminator = Discriminator.toJSON(message.discriminator);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IdPair>, I>>(base?: I): IdPair {
    return IdPair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IdPair>, I>>(object: I): IdPair {
    const message = createBaseIdPair();
    message.id = object.id ?? "";
    message.versionId = object.versionId ?? "";
    message.role = object.role ?? undefined;
    message.discriminator = (object.discriminator !== undefined && object.discriminator !== null)
      ? Discriminator.fromPartial(object.discriminator)
      : undefined;
    return message;
  },
};

function createBaseCategoryCollection(): CategoryCollection {
  return { customerId: undefined, carbon: undefined, id: "", name: "", categoryIds: [] };
}

export const CategoryCollection: MessageFns<CategoryCollection> = {
  encode(message: CategoryCollection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.customerId !== undefined) {
      writer.uint32(10).string(message.customerId);
    }
    if (message.carbon !== undefined) {
      Empty.encode(message.carbon, writer.uint32(18).fork()).join();
    }
    if (message.id !== "") {
      writer.uint32(26).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    for (const v of message.categoryIds) {
      IdPair.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CategoryCollection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCategoryCollection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.carbon = Empty.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.categoryIds.push(IdPair.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CategoryCollection {
    return {
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : undefined,
      carbon: isSet(object.carbon) ? Empty.fromJSON(object.carbon) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      categoryIds: globalThis.Array.isArray(object?.categoryIds)
        ? object.categoryIds.map((e: any) => IdPair.fromJSON(e))
        : globalThis.Array.isArray(object?.category_ids)
        ? object.category_ids.map((e: any) => IdPair.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CategoryCollection): unknown {
    const obj: any = {};
    if (message.customerId !== undefined) {
      obj.customerId = message.customerId;
    }
    if (message.carbon !== undefined) {
      obj.carbon = Empty.toJSON(message.carbon);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.categoryIds?.length) {
      obj.categoryIds = message.categoryIds.map((e) => IdPair.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CategoryCollection>, I>>(base?: I): CategoryCollection {
    return CategoryCollection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CategoryCollection>, I>>(object: I): CategoryCollection {
    const message = createBaseCategoryCollection();
    message.customerId = object.customerId ?? undefined;
    message.carbon = (object.carbon !== undefined && object.carbon !== null)
      ? Empty.fromPartial(object.carbon)
      : undefined;
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.categoryIds = object.categoryIds?.map((e) => IdPair.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSavedCategoryCollection(): SavedCategoryCollection {
  return { metadata: undefined, collection: undefined };
}

export const SavedCategoryCollection: MessageFns<SavedCategoryCollection> = {
  encode(message: SavedCategoryCollection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      SavedVersionMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.collection !== undefined) {
      CategoryCollection.encode(message.collection, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SavedCategoryCollection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSavedCategoryCollection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = SavedVersionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.collection = CategoryCollection.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SavedCategoryCollection {
    return {
      metadata: isSet(object.metadata) ? SavedVersionMetadata.fromJSON(object.metadata) : undefined,
      collection: isSet(object.collection) ? CategoryCollection.fromJSON(object.collection) : undefined,
    };
  },

  toJSON(message: SavedCategoryCollection): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = SavedVersionMetadata.toJSON(message.metadata);
    }
    if (message.collection !== undefined) {
      obj.collection = CategoryCollection.toJSON(message.collection);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SavedCategoryCollection>, I>>(base?: I): SavedCategoryCollection {
    return SavedCategoryCollection.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SavedCategoryCollection>, I>>(object: I): SavedCategoryCollection {
    const message = createBaseSavedCategoryCollection();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? SavedVersionMetadata.fromPartial(object.metadata)
      : undefined;
    message.collection = (object.collection !== undefined && object.collection !== null)
      ? CategoryCollection.fromPartial(object.collection)
      : undefined;
    return message;
  },
};

function createBasePlantProfile(): PlantProfile {
  return { customerId: undefined, carbon: undefined, id: "", name: "", categories: [], categoryMemberships: [] };
}

export const PlantProfile: MessageFns<PlantProfile> = {
  encode(message: PlantProfile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.customerId !== undefined) {
      writer.uint32(10).string(message.customerId);
    }
    if (message.carbon !== undefined) {
      Empty.encode(message.carbon, writer.uint32(18).fork()).join();
    }
    if (message.id !== "") {
      writer.uint32(26).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    for (const v of message.categories) {
      SavedCategory.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.categoryMemberships) {
      IdPair.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlantProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlantProfile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.carbon = Empty.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.categories.push(SavedCategory.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.categoryMemberships.push(IdPair.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlantProfile {
    return {
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : undefined,
      carbon: isSet(object.carbon) ? Empty.fromJSON(object.carbon) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      categories: globalThis.Array.isArray(object?.categories)
        ? object.categories.map((e: any) => SavedCategory.fromJSON(e))
        : [],
      categoryMemberships: globalThis.Array.isArray(object?.categoryMemberships)
        ? object.categoryMemberships.map((e: any) => IdPair.fromJSON(e))
        : globalThis.Array.isArray(object?.category_memberships)
        ? object.category_memberships.map((e: any) => IdPair.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PlantProfile): unknown {
    const obj: any = {};
    if (message.customerId !== undefined) {
      obj.customerId = message.customerId;
    }
    if (message.carbon !== undefined) {
      obj.carbon = Empty.toJSON(message.carbon);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.categories?.length) {
      obj.categories = message.categories.map((e) => SavedCategory.toJSON(e));
    }
    if (message.categoryMemberships?.length) {
      obj.categoryMemberships = message.categoryMemberships.map((e) => IdPair.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlantProfile>, I>>(base?: I): PlantProfile {
    return PlantProfile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlantProfile>, I>>(object: I): PlantProfile {
    const message = createBasePlantProfile();
    message.customerId = object.customerId ?? undefined;
    message.carbon = (object.carbon !== undefined && object.carbon !== null)
      ? Empty.fromPartial(object.carbon)
      : undefined;
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.categories = object.categories?.map((e) => SavedCategory.fromPartial(e)) || [];
    message.categoryMemberships = object.categoryMemberships?.map((e) => IdPair.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSavedPlantProfile(): SavedPlantProfile {
  return { metadata: undefined, profile: undefined };
}

export const SavedPlantProfile: MessageFns<SavedPlantProfile> = {
  encode(message: SavedPlantProfile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      SavedVersionMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.profile !== undefined) {
      PlantProfile.encode(message.profile, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SavedPlantProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSavedPlantProfile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = SavedVersionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.profile = PlantProfile.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SavedPlantProfile {
    return {
      metadata: isSet(object.metadata) ? SavedVersionMetadata.fromJSON(object.metadata) : undefined,
      profile: isSet(object.profile) ? PlantProfile.fromJSON(object.profile) : undefined,
    };
  },

  toJSON(message: SavedPlantProfile): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = SavedVersionMetadata.toJSON(message.metadata);
    }
    if (message.profile !== undefined) {
      obj.profile = PlantProfile.toJSON(message.profile);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SavedPlantProfile>, I>>(base?: I): SavedPlantProfile {
    return SavedPlantProfile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SavedPlantProfile>, I>>(object: I): SavedPlantProfile {
    const message = createBaseSavedPlantProfile();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? SavedVersionMetadata.fromPartial(object.metadata)
      : undefined;
    message.profile = (object.profile !== undefined && object.profile !== null)
      ? PlantProfile.fromPartial(object.profile)
      : undefined;
    return message;
  },
};

function createBaseTextSearch(): TextSearch {
  return { query: "" };
}

export const TextSearch: MessageFns<TextSearch> = {
  encode(message: TextSearch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.query !== "") {
      writer.uint32(10).string(message.query);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TextSearch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextSearch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.query = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TextSearch {
    return { query: isSet(object.query) ? globalThis.String(object.query) : "" };
  },

  toJSON(message: TextSearch): unknown {
    const obj: any = {};
    if (message.query !== "") {
      obj.query = message.query;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TextSearch>, I>>(base?: I): TextSearch {
    return TextSearch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TextSearch>, I>>(object: I): TextSearch {
    const message = createBaseTextSearch();
    message.query = object.query ?? "";
    return message;
  },
};

function createBaseProfileFilters(): ProfileFilters {
  return { customerId: undefined, carbon: undefined, search: undefined };
}

export const ProfileFilters: MessageFns<ProfileFilters> = {
  encode(message: ProfileFilters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.customerId !== undefined) {
      writer.uint32(10).string(message.customerId);
    }
    if (message.carbon !== undefined) {
      Empty.encode(message.carbon, writer.uint32(18).fork()).join();
    }
    if (message.search !== undefined) {
      TextSearch.encode(message.search, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProfileFilters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProfileFilters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.carbon = Empty.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.search = TextSearch.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProfileFilters {
    return {
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : undefined,
      carbon: isSet(object.carbon) ? Empty.fromJSON(object.carbon) : undefined,
      search: isSet(object.search) ? TextSearch.fromJSON(object.search) : undefined,
    };
  },

  toJSON(message: ProfileFilters): unknown {
    const obj: any = {};
    if (message.customerId !== undefined) {
      obj.customerId = message.customerId;
    }
    if (message.carbon !== undefined) {
      obj.carbon = Empty.toJSON(message.carbon);
    }
    if (message.search !== undefined) {
      obj.search = TextSearch.toJSON(message.search);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProfileFilters>, I>>(base?: I): ProfileFilters {
    return ProfileFilters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProfileFilters>, I>>(object: I): ProfileFilters {
    const message = createBaseProfileFilters();
    message.customerId = object.customerId ?? undefined;
    message.carbon = (object.carbon !== undefined && object.carbon !== null)
      ? Empty.fromPartial(object.carbon)
      : undefined;
    message.search = (object.search !== undefined && object.search !== null)
      ? TextSearch.fromPartial(object.search)
      : undefined;
    return message;
  },
};

function createBasePaginationRequest(): PaginationRequest {
  return { limit: 0, newer: undefined, older: undefined, asOf: undefined };
}

export const PaginationRequest: MessageFns<PaginationRequest> = {
  encode(message: PaginationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.limit !== 0) {
      writer.uint32(8).int64(message.limit);
    }
    if (message.newer !== undefined) {
      writer.uint32(18).string(message.newer);
    }
    if (message.older !== undefined) {
      writer.uint32(26).string(message.older);
    }
    if (message.asOf !== undefined) {
      Timestamp.encode(toTimestamp(message.asOf), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PaginationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaginationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.limit = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.newer = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.older = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.asOf = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaginationRequest {
    return {
      limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
      newer: isSet(object.newer) ? globalThis.String(object.newer) : undefined,
      older: isSet(object.older) ? globalThis.String(object.older) : undefined,
      asOf: isSet(object.asOf)
        ? globalThis.String(object.asOf)
        : isSet(object.as_of)
        ? globalThis.String(object.as_of)
        : undefined,
    };
  },

  toJSON(message: PaginationRequest): unknown {
    const obj: any = {};
    if (message.limit !== 0) {
      obj.limit = Math.round(message.limit);
    }
    if (message.newer !== undefined) {
      obj.newer = message.newer;
    }
    if (message.older !== undefined) {
      obj.older = message.older;
    }
    if (message.asOf !== undefined) {
      obj.asOf = message.asOf;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PaginationRequest>, I>>(base?: I): PaginationRequest {
    return PaginationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PaginationRequest>, I>>(object: I): PaginationRequest {
    const message = createBasePaginationRequest();
    message.limit = object.limit ?? 0;
    message.newer = object.newer ?? undefined;
    message.older = object.older ?? undefined;
    message.asOf = object.asOf ?? undefined;
    return message;
  },
};

function createBasePaginationResponse(): PaginationResponse {
  return { nextOld: undefined, nextNew: undefined, asOf: undefined };
}

export const PaginationResponse: MessageFns<PaginationResponse> = {
  encode(message: PaginationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nextOld !== undefined) {
      writer.uint32(10).string(message.nextOld);
    }
    if (message.nextNew !== undefined) {
      writer.uint32(18).string(message.nextNew);
    }
    if (message.asOf !== undefined) {
      Timestamp.encode(toTimestamp(message.asOf), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PaginationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaginationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nextOld = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextNew = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.asOf = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaginationResponse {
    return {
      nextOld: isSet(object.nextOld)
        ? globalThis.String(object.nextOld)
        : isSet(object.next_old)
        ? globalThis.String(object.next_old)
        : undefined,
      nextNew: isSet(object.nextNew)
        ? globalThis.String(object.nextNew)
        : isSet(object.next_new)
        ? globalThis.String(object.next_new)
        : undefined,
      asOf: isSet(object.asOf)
        ? globalThis.String(object.asOf)
        : isSet(object.as_of)
        ? globalThis.String(object.as_of)
        : undefined,
    };
  },

  toJSON(message: PaginationResponse): unknown {
    const obj: any = {};
    if (message.nextOld !== undefined) {
      obj.nextOld = message.nextOld;
    }
    if (message.nextNew !== undefined) {
      obj.nextNew = message.nextNew;
    }
    if (message.asOf !== undefined) {
      obj.asOf = message.asOf;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PaginationResponse>, I>>(base?: I): PaginationResponse {
    return PaginationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PaginationResponse>, I>>(object: I): PaginationResponse {
    const message = createBasePaginationResponse();
    message.nextOld = object.nextOld ?? undefined;
    message.nextNew = object.nextNew ?? undefined;
    message.asOf = object.asOf ?? undefined;
    return message;
  },
};

function createBaseRevertProfile(): RevertProfile {
  return { id: "", revertVersionId: "" };
}

export const RevertProfile: MessageFns<RevertProfile> = {
  encode(message: RevertProfile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.revertVersionId !== "") {
      writer.uint32(18).string(message.revertVersionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevertProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRevertProfile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.revertVersionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RevertProfile {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      revertVersionId: isSet(object.revertVersionId)
        ? globalThis.String(object.revertVersionId)
        : isSet(object.revert_version_id)
        ? globalThis.String(object.revert_version_id)
        : "",
    };
  },

  toJSON(message: RevertProfile): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.revertVersionId !== "") {
      obj.revertVersionId = message.revertVersionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RevertProfile>, I>>(base?: I): RevertProfile {
    return RevertProfile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RevertProfile>, I>>(object: I): RevertProfile {
    const message = createBaseRevertProfile();
    message.id = object.id ?? "";
    message.revertVersionId = object.revertVersionId ?? "";
    return message;
  },
};

function createBaseListCategoriesRequest(): ListCategoriesRequest {
  return { filters: undefined, pagination: undefined, inLibrary: undefined, includeCustomCategories: false };
}

export const ListCategoriesRequest: MessageFns<ListCategoriesRequest> = {
  encode(message: ListCategoriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filters !== undefined) {
      ProfileFilters.encode(message.filters, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    if (message.inLibrary !== undefined) {
      writer.uint32(24).bool(message.inLibrary);
    }
    if (message.includeCustomCategories !== false) {
      writer.uint32(32).bool(message.includeCustomCategories);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCategoriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCategoriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filters = ProfileFilters.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.inLibrary = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.includeCustomCategories = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCategoriesRequest {
    return {
      filters: isSet(object.filters) ? ProfileFilters.fromJSON(object.filters) : undefined,
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
      inLibrary: isSet(object.inLibrary)
        ? globalThis.Boolean(object.inLibrary)
        : isSet(object.in_library)
        ? globalThis.Boolean(object.in_library)
        : undefined,
      includeCustomCategories: isSet(object.includeCustomCategories)
        ? globalThis.Boolean(object.includeCustomCategories)
        : isSet(object.include_custom_categories)
        ? globalThis.Boolean(object.include_custom_categories)
        : false,
    };
  },

  toJSON(message: ListCategoriesRequest): unknown {
    const obj: any = {};
    if (message.filters !== undefined) {
      obj.filters = ProfileFilters.toJSON(message.filters);
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    if (message.inLibrary !== undefined) {
      obj.inLibrary = message.inLibrary;
    }
    if (message.includeCustomCategories !== false) {
      obj.includeCustomCategories = message.includeCustomCategories;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCategoriesRequest>, I>>(base?: I): ListCategoriesRequest {
    return ListCategoriesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCategoriesRequest>, I>>(object: I): ListCategoriesRequest {
    const message = createBaseListCategoriesRequest();
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? ProfileFilters.fromPartial(object.filters)
      : undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    message.inLibrary = object.inLibrary ?? undefined;
    message.includeCustomCategories = object.includeCustomCategories ?? false;
    return message;
  },
};

function createBaseListCategoriesResponse(): ListCategoriesResponse {
  return { categories: [], pagination: undefined };
}

export const ListCategoriesResponse: MessageFns<ListCategoriesResponse> = {
  encode(message: ListCategoriesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.categories) {
      SavedCategory.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCategoriesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCategoriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.categories.push(SavedCategory.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCategoriesResponse {
    return {
      categories: globalThis.Array.isArray(object?.categories)
        ? object.categories.map((e: any) => SavedCategory.fromJSON(e))
        : [],
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: ListCategoriesResponse): unknown {
    const obj: any = {};
    if (message.categories?.length) {
      obj.categories = message.categories.map((e) => SavedCategory.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCategoriesResponse>, I>>(base?: I): ListCategoriesResponse {
    return ListCategoriesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCategoriesResponse>, I>>(object: I): ListCategoriesResponse {
    const message = createBaseListCategoriesResponse();
    message.categories = object.categories?.map((e) => SavedCategory.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetCategoryRequest(): GetCategoryRequest {
  return { id: "", includeDeleted: false };
}

export const GetCategoryRequest: MessageFns<GetCategoryRequest> = {
  encode(message: GetCategoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.includeDeleted !== false) {
      writer.uint32(16).bool(message.includeDeleted);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.includeDeleted = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      includeDeleted: isSet(object.includeDeleted)
        ? globalThis.Boolean(object.includeDeleted)
        : isSet(object.include_deleted)
        ? globalThis.Boolean(object.include_deleted)
        : false,
    };
  },

  toJSON(message: GetCategoryRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.includeDeleted !== false) {
      obj.includeDeleted = message.includeDeleted;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryRequest>, I>>(base?: I): GetCategoryRequest {
    return GetCategoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryRequest>, I>>(object: I): GetCategoryRequest {
    const message = createBaseGetCategoryRequest();
    message.id = object.id ?? "";
    message.includeDeleted = object.includeDeleted ?? false;
    return message;
  },
};

function createBaseCreateCategoryRequest(): CreateCategoryRequest {
  return { metadata: undefined, category: undefined };
}

export const CreateCategoryRequest: MessageFns<CreateCategoryRequest> = {
  encode(message: CreateCategoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      BaseVersionMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.category !== undefined) {
      Category.encode(message.category, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCategoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCategoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = BaseVersionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.category = Category.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCategoryRequest {
    return {
      metadata: isSet(object.metadata) ? BaseVersionMetadata.fromJSON(object.metadata) : undefined,
      category: isSet(object.category) ? Category.fromJSON(object.category) : undefined,
    };
  },

  toJSON(message: CreateCategoryRequest): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = BaseVersionMetadata.toJSON(message.metadata);
    }
    if (message.category !== undefined) {
      obj.category = Category.toJSON(message.category);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateCategoryRequest>, I>>(base?: I): CreateCategoryRequest {
    return CreateCategoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateCategoryRequest>, I>>(object: I): CreateCategoryRequest {
    const message = createBaseCreateCategoryRequest();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? BaseVersionMetadata.fromPartial(object.metadata)
      : undefined;
    message.category = (object.category !== undefined && object.category !== null)
      ? Category.fromPartial(object.category)
      : undefined;
    return message;
  },
};

function createBaseAddCategoryVersionRequest(): AddCategoryVersionRequest {
  return { metadata: undefined, category: undefined, revert: undefined };
}

export const AddCategoryVersionRequest: MessageFns<AddCategoryVersionRequest> = {
  encode(message: AddCategoryVersionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      AddVersionMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.category !== undefined) {
      Category.encode(message.category, writer.uint32(18).fork()).join();
    }
    if (message.revert !== undefined) {
      RevertProfile.encode(message.revert, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddCategoryVersionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddCategoryVersionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = AddVersionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.category = Category.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.revert = RevertProfile.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddCategoryVersionRequest {
    return {
      metadata: isSet(object.metadata) ? AddVersionMetadata.fromJSON(object.metadata) : undefined,
      category: isSet(object.category) ? Category.fromJSON(object.category) : undefined,
      revert: isSet(object.revert) ? RevertProfile.fromJSON(object.revert) : undefined,
    };
  },

  toJSON(message: AddCategoryVersionRequest): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = AddVersionMetadata.toJSON(message.metadata);
    }
    if (message.category !== undefined) {
      obj.category = Category.toJSON(message.category);
    }
    if (message.revert !== undefined) {
      obj.revert = RevertProfile.toJSON(message.revert);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddCategoryVersionRequest>, I>>(base?: I): AddCategoryVersionRequest {
    return AddCategoryVersionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddCategoryVersionRequest>, I>>(object: I): AddCategoryVersionRequest {
    const message = createBaseAddCategoryVersionRequest();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? AddVersionMetadata.fromPartial(object.metadata)
      : undefined;
    message.category = (object.category !== undefined && object.category !== null)
      ? Category.fromPartial(object.category)
      : undefined;
    message.revert = (object.revert !== undefined && object.revert !== null)
      ? RevertProfile.fromPartial(object.revert)
      : undefined;
    return message;
  },
};

function createBaseDeleteCategoryRequest(): DeleteCategoryRequest {
  return { metadata: undefined, id: "" };
}

export const DeleteCategoryRequest: MessageFns<DeleteCategoryRequest> = {
  encode(message: DeleteCategoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      BaseVersionMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCategoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCategoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = BaseVersionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteCategoryRequest {
    return {
      metadata: isSet(object.metadata) ? BaseVersionMetadata.fromJSON(object.metadata) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: DeleteCategoryRequest): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = BaseVersionMetadata.toJSON(message.metadata);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteCategoryRequest>, I>>(base?: I): DeleteCategoryRequest {
    return DeleteCategoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteCategoryRequest>, I>>(object: I): DeleteCategoryRequest {
    const message = createBaseDeleteCategoryRequest();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? BaseVersionMetadata.fromPartial(object.metadata)
      : undefined;
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseDeleteCategoryResponse(): DeleteCategoryResponse {
  return {};
}

export const DeleteCategoryResponse: MessageFns<DeleteCategoryResponse> = {
  encode(_: DeleteCategoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCategoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCategoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteCategoryResponse {
    return {};
  },

  toJSON(_: DeleteCategoryResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteCategoryResponse>, I>>(base?: I): DeleteCategoryResponse {
    return DeleteCategoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteCategoryResponse>, I>>(_: I): DeleteCategoryResponse {
    const message = createBaseDeleteCategoryResponse();
    return message;
  },
};

function createBaseListCategoryCollectionsRequest(): ListCategoryCollectionsRequest {
  return { filters: undefined, pagination: undefined, includeCustomCategories: false };
}

export const ListCategoryCollectionsRequest: MessageFns<ListCategoryCollectionsRequest> = {
  encode(message: ListCategoryCollectionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filters !== undefined) {
      ProfileFilters.encode(message.filters, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    if (message.includeCustomCategories !== false) {
      writer.uint32(24).bool(message.includeCustomCategories);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCategoryCollectionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCategoryCollectionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filters = ProfileFilters.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includeCustomCategories = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCategoryCollectionsRequest {
    return {
      filters: isSet(object.filters) ? ProfileFilters.fromJSON(object.filters) : undefined,
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
      includeCustomCategories: isSet(object.includeCustomCategories)
        ? globalThis.Boolean(object.includeCustomCategories)
        : isSet(object.include_custom_categories)
        ? globalThis.Boolean(object.include_custom_categories)
        : false,
    };
  },

  toJSON(message: ListCategoryCollectionsRequest): unknown {
    const obj: any = {};
    if (message.filters !== undefined) {
      obj.filters = ProfileFilters.toJSON(message.filters);
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    if (message.includeCustomCategories !== false) {
      obj.includeCustomCategories = message.includeCustomCategories;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCategoryCollectionsRequest>, I>>(base?: I): ListCategoryCollectionsRequest {
    return ListCategoryCollectionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCategoryCollectionsRequest>, I>>(
    object: I,
  ): ListCategoryCollectionsRequest {
    const message = createBaseListCategoryCollectionsRequest();
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? ProfileFilters.fromPartial(object.filters)
      : undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    message.includeCustomCategories = object.includeCustomCategories ?? false;
    return message;
  },
};

function createBaseListCategoryCollectionsResponse(): ListCategoryCollectionsResponse {
  return { collections: [], pagination: undefined };
}

export const ListCategoryCollectionsResponse: MessageFns<ListCategoryCollectionsResponse> = {
  encode(message: ListCategoryCollectionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.collections) {
      SavedCategoryCollection.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCategoryCollectionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCategoryCollectionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.collections.push(SavedCategoryCollection.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCategoryCollectionsResponse {
    return {
      collections: globalThis.Array.isArray(object?.collections)
        ? object.collections.map((e: any) => SavedCategoryCollection.fromJSON(e))
        : [],
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: ListCategoryCollectionsResponse): unknown {
    const obj: any = {};
    if (message.collections?.length) {
      obj.collections = message.collections.map((e) => SavedCategoryCollection.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCategoryCollectionsResponse>, I>>(base?: I): ListCategoryCollectionsResponse {
    return ListCategoryCollectionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCategoryCollectionsResponse>, I>>(
    object: I,
  ): ListCategoryCollectionsResponse {
    const message = createBaseListCategoryCollectionsResponse();
    message.collections = object.collections?.map((e) => SavedCategoryCollection.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetCategoryCollectionRequest(): GetCategoryCollectionRequest {
  return { id: "" };
}

export const GetCategoryCollectionRequest: MessageFns<GetCategoryCollectionRequest> = {
  encode(message: GetCategoryCollectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryCollectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryCollectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryCollectionRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: GetCategoryCollectionRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryCollectionRequest>, I>>(base?: I): GetCategoryCollectionRequest {
    return GetCategoryCollectionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryCollectionRequest>, I>>(object: I): GetCategoryCollectionRequest {
    const message = createBaseGetCategoryCollectionRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseSetCategoryCollectionVersionActiveRequest(): SetCategoryCollectionVersionActiveRequest {
  return { userId: "", id: "", versionId: "", lastKnownActiveVersionId: undefined };
}

export const SetCategoryCollectionVersionActiveRequest: MessageFns<SetCategoryCollectionVersionActiveRequest> = {
  encode(message: SetCategoryCollectionVersionActiveRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.versionId !== "") {
      writer.uint32(26).string(message.versionId);
    }
    if (message.lastKnownActiveVersionId !== undefined) {
      writer.uint32(34).string(message.lastKnownActiveVersionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetCategoryCollectionVersionActiveRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCategoryCollectionVersionActiveRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.lastKnownActiveVersionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetCategoryCollectionVersionActiveRequest {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : "",
      lastKnownActiveVersionId: isSet(object.lastKnownActiveVersionId)
        ? globalThis.String(object.lastKnownActiveVersionId)
        : isSet(object.last_known_active_version_id)
        ? globalThis.String(object.last_known_active_version_id)
        : undefined,
    };
  },

  toJSON(message: SetCategoryCollectionVersionActiveRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.versionId !== "") {
      obj.versionId = message.versionId;
    }
    if (message.lastKnownActiveVersionId !== undefined) {
      obj.lastKnownActiveVersionId = message.lastKnownActiveVersionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCategoryCollectionVersionActiveRequest>, I>>(
    base?: I,
  ): SetCategoryCollectionVersionActiveRequest {
    return SetCategoryCollectionVersionActiveRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCategoryCollectionVersionActiveRequest>, I>>(
    object: I,
  ): SetCategoryCollectionVersionActiveRequest {
    const message = createBaseSetCategoryCollectionVersionActiveRequest();
    message.userId = object.userId ?? "";
    message.id = object.id ?? "";
    message.versionId = object.versionId ?? "";
    message.lastKnownActiveVersionId = object.lastKnownActiveVersionId ?? undefined;
    return message;
  },
};

function createBaseSetCategoryCollectionVersionActiveResponse(): SetCategoryCollectionVersionActiveResponse {
  return {};
}

export const SetCategoryCollectionVersionActiveResponse: MessageFns<SetCategoryCollectionVersionActiveResponse> = {
  encode(_: SetCategoryCollectionVersionActiveResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetCategoryCollectionVersionActiveResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCategoryCollectionVersionActiveResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetCategoryCollectionVersionActiveResponse {
    return {};
  },

  toJSON(_: SetCategoryCollectionVersionActiveResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCategoryCollectionVersionActiveResponse>, I>>(
    base?: I,
  ): SetCategoryCollectionVersionActiveResponse {
    return SetCategoryCollectionVersionActiveResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCategoryCollectionVersionActiveResponse>, I>>(
    _: I,
  ): SetCategoryCollectionVersionActiveResponse {
    const message = createBaseSetCategoryCollectionVersionActiveResponse();
    return message;
  },
};

function createBaseSetCategoryVersionActiveRequest(): SetCategoryVersionActiveRequest {
  return { userId: "", id: "", versionId: "", lastKnownActiveVersionId: undefined };
}

export const SetCategoryVersionActiveRequest: MessageFns<SetCategoryVersionActiveRequest> = {
  encode(message: SetCategoryVersionActiveRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.versionId !== "") {
      writer.uint32(26).string(message.versionId);
    }
    if (message.lastKnownActiveVersionId !== undefined) {
      writer.uint32(34).string(message.lastKnownActiveVersionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetCategoryVersionActiveRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCategoryVersionActiveRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.lastKnownActiveVersionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetCategoryVersionActiveRequest {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : "",
      lastKnownActiveVersionId: isSet(object.lastKnownActiveVersionId)
        ? globalThis.String(object.lastKnownActiveVersionId)
        : isSet(object.last_known_active_version_id)
        ? globalThis.String(object.last_known_active_version_id)
        : undefined,
    };
  },

  toJSON(message: SetCategoryVersionActiveRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.versionId !== "") {
      obj.versionId = message.versionId;
    }
    if (message.lastKnownActiveVersionId !== undefined) {
      obj.lastKnownActiveVersionId = message.lastKnownActiveVersionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCategoryVersionActiveRequest>, I>>(base?: I): SetCategoryVersionActiveRequest {
    return SetCategoryVersionActiveRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCategoryVersionActiveRequest>, I>>(
    object: I,
  ): SetCategoryVersionActiveRequest {
    const message = createBaseSetCategoryVersionActiveRequest();
    message.userId = object.userId ?? "";
    message.id = object.id ?? "";
    message.versionId = object.versionId ?? "";
    message.lastKnownActiveVersionId = object.lastKnownActiveVersionId ?? undefined;
    return message;
  },
};

function createBaseSetCategoryVersionActiveResponse(): SetCategoryVersionActiveResponse {
  return {};
}

export const SetCategoryVersionActiveResponse: MessageFns<SetCategoryVersionActiveResponse> = {
  encode(_: SetCategoryVersionActiveResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetCategoryVersionActiveResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetCategoryVersionActiveResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetCategoryVersionActiveResponse {
    return {};
  },

  toJSON(_: SetCategoryVersionActiveResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetCategoryVersionActiveResponse>, I>>(
    base?: I,
  ): SetCategoryVersionActiveResponse {
    return SetCategoryVersionActiveResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetCategoryVersionActiveResponse>, I>>(
    _: I,
  ): SetCategoryVersionActiveResponse {
    const message = createBaseSetCategoryVersionActiveResponse();
    return message;
  },
};

function createBaseListPlantProfilesRequest(): ListPlantProfilesRequest {
  return { filters: undefined, pagination: undefined, includeCustomCategories: false };
}

export const ListPlantProfilesRequest: MessageFns<ListPlantProfilesRequest> = {
  encode(message: ListPlantProfilesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filters !== undefined) {
      ProfileFilters.encode(message.filters, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    if (message.includeCustomCategories !== false) {
      writer.uint32(24).bool(message.includeCustomCategories);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPlantProfilesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPlantProfilesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filters = ProfileFilters.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includeCustomCategories = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPlantProfilesRequest {
    return {
      filters: isSet(object.filters) ? ProfileFilters.fromJSON(object.filters) : undefined,
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
      includeCustomCategories: isSet(object.includeCustomCategories)
        ? globalThis.Boolean(object.includeCustomCategories)
        : isSet(object.include_custom_categories)
        ? globalThis.Boolean(object.include_custom_categories)
        : false,
    };
  },

  toJSON(message: ListPlantProfilesRequest): unknown {
    const obj: any = {};
    if (message.filters !== undefined) {
      obj.filters = ProfileFilters.toJSON(message.filters);
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    if (message.includeCustomCategories !== false) {
      obj.includeCustomCategories = message.includeCustomCategories;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPlantProfilesRequest>, I>>(base?: I): ListPlantProfilesRequest {
    return ListPlantProfilesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPlantProfilesRequest>, I>>(object: I): ListPlantProfilesRequest {
    const message = createBaseListPlantProfilesRequest();
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? ProfileFilters.fromPartial(object.filters)
      : undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    message.includeCustomCategories = object.includeCustomCategories ?? false;
    return message;
  },
};

function createBaseListPlantProfilesResponse(): ListPlantProfilesResponse {
  return { plantProfiles: [], pagination: undefined };
}

export const ListPlantProfilesResponse: MessageFns<ListPlantProfilesResponse> = {
  encode(message: ListPlantProfilesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.plantProfiles) {
      SavedPlantProfile.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPlantProfilesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPlantProfilesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.plantProfiles.push(SavedPlantProfile.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPlantProfilesResponse {
    return {
      plantProfiles: globalThis.Array.isArray(object?.plantProfiles)
        ? object.plantProfiles.map((e: any) => SavedPlantProfile.fromJSON(e))
        : globalThis.Array.isArray(object?.plant_profiles)
        ? object.plant_profiles.map((e: any) => SavedPlantProfile.fromJSON(e))
        : [],
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: ListPlantProfilesResponse): unknown {
    const obj: any = {};
    if (message.plantProfiles?.length) {
      obj.plantProfiles = message.plantProfiles.map((e) => SavedPlantProfile.toJSON(e));
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPlantProfilesResponse>, I>>(base?: I): ListPlantProfilesResponse {
    return ListPlantProfilesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPlantProfilesResponse>, I>>(object: I): ListPlantProfilesResponse {
    const message = createBaseListPlantProfilesResponse();
    message.plantProfiles = object.plantProfiles?.map((e) => SavedPlantProfile.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetPlantProfileRequest(): GetPlantProfileRequest {
  return { id: "" };
}

export const GetPlantProfileRequest: MessageFns<GetPlantProfileRequest> = {
  encode(message: GetPlantProfileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPlantProfileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPlantProfileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPlantProfileRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: GetPlantProfileRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPlantProfileRequest>, I>>(base?: I): GetPlantProfileRequest {
    return GetPlantProfileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPlantProfileRequest>, I>>(object: I): GetPlantProfileRequest {
    const message = createBaseGetPlantProfileRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseBaseTransactionMetadata(): BaseTransactionMetadata {
  return { userId: "", clientVersionCreateTime: undefined };
}

export const BaseTransactionMetadata: MessageFns<BaseTransactionMetadata> = {
  encode(message: BaseTransactionMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    if (message.clientVersionCreateTime !== undefined) {
      Timestamp.encode(toTimestamp(message.clientVersionCreateTime), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BaseTransactionMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBaseTransactionMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.clientVersionCreateTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BaseTransactionMetadata {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
        ? globalThis.String(object.user_id)
        : "",
      clientVersionCreateTime: isSet(object.clientVersionCreateTime)
        ? globalThis.String(object.clientVersionCreateTime)
        : isSet(object.client_version_create_time)
        ? globalThis.String(object.client_version_create_time)
        : undefined,
    };
  },

  toJSON(message: BaseTransactionMetadata): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.clientVersionCreateTime !== undefined) {
      obj.clientVersionCreateTime = message.clientVersionCreateTime;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BaseTransactionMetadata>, I>>(base?: I): BaseTransactionMetadata {
    return BaseTransactionMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BaseTransactionMetadata>, I>>(object: I): BaseTransactionMetadata {
    const message = createBaseBaseTransactionMetadata();
    message.userId = object.userId ?? "";
    message.clientVersionCreateTime = object.clientVersionCreateTime ?? undefined;
    return message;
  },
};

function createBaseCreateMetadataInTransaction(): CreateMetadataInTransaction {
  return { versionId: "" };
}

export const CreateMetadataInTransaction: MessageFns<CreateMetadataInTransaction> = {
  encode(message: CreateMetadataInTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.versionId !== "") {
      writer.uint32(10).string(message.versionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateMetadataInTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateMetadataInTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateMetadataInTransaction {
    return {
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : "",
    };
  },

  toJSON(message: CreateMetadataInTransaction): unknown {
    const obj: any = {};
    if (message.versionId !== "") {
      obj.versionId = message.versionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateMetadataInTransaction>, I>>(base?: I): CreateMetadataInTransaction {
    return CreateMetadataInTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateMetadataInTransaction>, I>>(object: I): CreateMetadataInTransaction {
    const message = createBaseCreateMetadataInTransaction();
    message.versionId = object.versionId ?? "";
    return message;
  },
};

function createBaseAddVersionMetadataInTransaction(): AddVersionMetadataInTransaction {
  return { versionId: "", parentVersionId: "", active: false, lastKnownActiveVersionId: undefined };
}

export const AddVersionMetadataInTransaction: MessageFns<AddVersionMetadataInTransaction> = {
  encode(message: AddVersionMetadataInTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.versionId !== "") {
      writer.uint32(10).string(message.versionId);
    }
    if (message.parentVersionId !== "") {
      writer.uint32(18).string(message.parentVersionId);
    }
    if (message.active !== false) {
      writer.uint32(24).bool(message.active);
    }
    if (message.lastKnownActiveVersionId !== undefined) {
      writer.uint32(34).string(message.lastKnownActiveVersionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddVersionMetadataInTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddVersionMetadataInTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.parentVersionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.lastKnownActiveVersionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddVersionMetadataInTransaction {
    return {
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : "",
      parentVersionId: isSet(object.parentVersionId)
        ? globalThis.String(object.parentVersionId)
        : isSet(object.parent_version_id)
        ? globalThis.String(object.parent_version_id)
        : "",
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      lastKnownActiveVersionId: isSet(object.lastKnownActiveVersionId)
        ? globalThis.String(object.lastKnownActiveVersionId)
        : isSet(object.last_known_active_version_id)
        ? globalThis.String(object.last_known_active_version_id)
        : undefined,
    };
  },

  toJSON(message: AddVersionMetadataInTransaction): unknown {
    const obj: any = {};
    if (message.versionId !== "") {
      obj.versionId = message.versionId;
    }
    if (message.parentVersionId !== "") {
      obj.parentVersionId = message.parentVersionId;
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.lastKnownActiveVersionId !== undefined) {
      obj.lastKnownActiveVersionId = message.lastKnownActiveVersionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddVersionMetadataInTransaction>, I>>(base?: I): AddVersionMetadataInTransaction {
    return AddVersionMetadataInTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddVersionMetadataInTransaction>, I>>(
    object: I,
  ): AddVersionMetadataInTransaction {
    const message = createBaseAddVersionMetadataInTransaction();
    message.versionId = object.versionId ?? "";
    message.parentVersionId = object.parentVersionId ?? "";
    message.active = object.active ?? false;
    message.lastKnownActiveVersionId = object.lastKnownActiveVersionId ?? undefined;
    return message;
  },
};

function createBaseDeleteMetadataInTransaction(): DeleteMetadataInTransaction {
  return { parentVersionId: "", active: false, lastKnownActiveVersionId: undefined };
}

export const DeleteMetadataInTransaction: MessageFns<DeleteMetadataInTransaction> = {
  encode(message: DeleteMetadataInTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.parentVersionId !== "") {
      writer.uint32(10).string(message.parentVersionId);
    }
    if (message.active !== false) {
      writer.uint32(16).bool(message.active);
    }
    if (message.lastKnownActiveVersionId !== undefined) {
      writer.uint32(26).string(message.lastKnownActiveVersionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteMetadataInTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteMetadataInTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.parentVersionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lastKnownActiveVersionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteMetadataInTransaction {
    return {
      parentVersionId: isSet(object.parentVersionId)
        ? globalThis.String(object.parentVersionId)
        : isSet(object.parent_version_id)
        ? globalThis.String(object.parent_version_id)
        : "",
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      lastKnownActiveVersionId: isSet(object.lastKnownActiveVersionId)
        ? globalThis.String(object.lastKnownActiveVersionId)
        : isSet(object.last_known_active_version_id)
        ? globalThis.String(object.last_known_active_version_id)
        : undefined,
    };
  },

  toJSON(message: DeleteMetadataInTransaction): unknown {
    const obj: any = {};
    if (message.parentVersionId !== "") {
      obj.parentVersionId = message.parentVersionId;
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.lastKnownActiveVersionId !== undefined) {
      obj.lastKnownActiveVersionId = message.lastKnownActiveVersionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteMetadataInTransaction>, I>>(base?: I): DeleteMetadataInTransaction {
    return DeleteMetadataInTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteMetadataInTransaction>, I>>(object: I): DeleteMetadataInTransaction {
    const message = createBaseDeleteMetadataInTransaction();
    message.parentVersionId = object.parentVersionId ?? "";
    message.active = object.active ?? false;
    message.lastKnownActiveVersionId = object.lastKnownActiveVersionId ?? undefined;
    return message;
  },
};

function createBaseCreateCategoryInTransaction(): CreateCategoryInTransaction {
  return { metadata: undefined, category: undefined, library: undefined };
}

export const CreateCategoryInTransaction: MessageFns<CreateCategoryInTransaction> = {
  encode(message: CreateCategoryInTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      CreateMetadataInTransaction.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.category !== undefined) {
      Category.encode(message.category, writer.uint32(18).fork()).join();
    }
    if (message.library !== undefined) {
      writer.uint32(24).bool(message.library);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCategoryInTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCategoryInTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = CreateMetadataInTransaction.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.category = Category.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.library = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCategoryInTransaction {
    return {
      metadata: isSet(object.metadata) ? CreateMetadataInTransaction.fromJSON(object.metadata) : undefined,
      category: isSet(object.category) ? Category.fromJSON(object.category) : undefined,
      library: isSet(object.library) ? globalThis.Boolean(object.library) : undefined,
    };
  },

  toJSON(message: CreateCategoryInTransaction): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = CreateMetadataInTransaction.toJSON(message.metadata);
    }
    if (message.category !== undefined) {
      obj.category = Category.toJSON(message.category);
    }
    if (message.library !== undefined) {
      obj.library = message.library;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateCategoryInTransaction>, I>>(base?: I): CreateCategoryInTransaction {
    return CreateCategoryInTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateCategoryInTransaction>, I>>(object: I): CreateCategoryInTransaction {
    const message = createBaseCreateCategoryInTransaction();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? CreateMetadataInTransaction.fromPartial(object.metadata)
      : undefined;
    message.category = (object.category !== undefined && object.category !== null)
      ? Category.fromPartial(object.category)
      : undefined;
    message.library = object.library ?? undefined;
    return message;
  },
};

function createBaseAddCategoryVersionInTransaction(): AddCategoryVersionInTransaction {
  return { metadata: undefined, category: undefined, revert: undefined };
}

export const AddCategoryVersionInTransaction: MessageFns<AddCategoryVersionInTransaction> = {
  encode(message: AddCategoryVersionInTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      AddVersionMetadataInTransaction.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.category !== undefined) {
      Category.encode(message.category, writer.uint32(18).fork()).join();
    }
    if (message.revert !== undefined) {
      RevertProfile.encode(message.revert, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddCategoryVersionInTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddCategoryVersionInTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = AddVersionMetadataInTransaction.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.category = Category.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.revert = RevertProfile.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddCategoryVersionInTransaction {
    return {
      metadata: isSet(object.metadata) ? AddVersionMetadataInTransaction.fromJSON(object.metadata) : undefined,
      category: isSet(object.category) ? Category.fromJSON(object.category) : undefined,
      revert: isSet(object.revert) ? RevertProfile.fromJSON(object.revert) : undefined,
    };
  },

  toJSON(message: AddCategoryVersionInTransaction): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = AddVersionMetadataInTransaction.toJSON(message.metadata);
    }
    if (message.category !== undefined) {
      obj.category = Category.toJSON(message.category);
    }
    if (message.revert !== undefined) {
      obj.revert = RevertProfile.toJSON(message.revert);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddCategoryVersionInTransaction>, I>>(base?: I): AddCategoryVersionInTransaction {
    return AddCategoryVersionInTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddCategoryVersionInTransaction>, I>>(
    object: I,
  ): AddCategoryVersionInTransaction {
    const message = createBaseAddCategoryVersionInTransaction();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? AddVersionMetadataInTransaction.fromPartial(object.metadata)
      : undefined;
    message.category = (object.category !== undefined && object.category !== null)
      ? Category.fromPartial(object.category)
      : undefined;
    message.revert = (object.revert !== undefined && object.revert !== null)
      ? RevertProfile.fromPartial(object.revert)
      : undefined;
    return message;
  },
};

function createBaseDeleteCategoryInTransaction(): DeleteCategoryInTransaction {
  return { id: "", metadata: undefined };
}

export const DeleteCategoryInTransaction: MessageFns<DeleteCategoryInTransaction> = {
  encode(message: DeleteCategoryInTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.metadata !== undefined) {
      DeleteMetadataInTransaction.encode(message.metadata, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCategoryInTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCategoryInTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata = DeleteMetadataInTransaction.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteCategoryInTransaction {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      metadata: isSet(object.metadata) ? DeleteMetadataInTransaction.fromJSON(object.metadata) : undefined,
    };
  },

  toJSON(message: DeleteCategoryInTransaction): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.metadata !== undefined) {
      obj.metadata = DeleteMetadataInTransaction.toJSON(message.metadata);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteCategoryInTransaction>, I>>(base?: I): DeleteCategoryInTransaction {
    return DeleteCategoryInTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteCategoryInTransaction>, I>>(object: I): DeleteCategoryInTransaction {
    const message = createBaseDeleteCategoryInTransaction();
    message.id = object.id ?? "";
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? DeleteMetadataInTransaction.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

function createBaseCategoryChange(): CategoryChange {
  return { create: undefined, update: undefined, delete: undefined };
}

export const CategoryChange: MessageFns<CategoryChange> = {
  encode(message: CategoryChange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.create !== undefined) {
      CreateCategoryInTransaction.encode(message.create, writer.uint32(10).fork()).join();
    }
    if (message.update !== undefined) {
      AddCategoryVersionInTransaction.encode(message.update, writer.uint32(18).fork()).join();
    }
    if (message.delete !== undefined) {
      DeleteCategoryInTransaction.encode(message.delete, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CategoryChange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCategoryChange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.create = CreateCategoryInTransaction.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.update = AddCategoryVersionInTransaction.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.delete = DeleteCategoryInTransaction.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CategoryChange {
    return {
      create: isSet(object.create) ? CreateCategoryInTransaction.fromJSON(object.create) : undefined,
      update: isSet(object.update) ? AddCategoryVersionInTransaction.fromJSON(object.update) : undefined,
      delete: isSet(object.delete) ? DeleteCategoryInTransaction.fromJSON(object.delete) : undefined,
    };
  },

  toJSON(message: CategoryChange): unknown {
    const obj: any = {};
    if (message.create !== undefined) {
      obj.create = CreateCategoryInTransaction.toJSON(message.create);
    }
    if (message.update !== undefined) {
      obj.update = AddCategoryVersionInTransaction.toJSON(message.update);
    }
    if (message.delete !== undefined) {
      obj.delete = DeleteCategoryInTransaction.toJSON(message.delete);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CategoryChange>, I>>(base?: I): CategoryChange {
    return CategoryChange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CategoryChange>, I>>(object: I): CategoryChange {
    const message = createBaseCategoryChange();
    message.create = (object.create !== undefined && object.create !== null)
      ? CreateCategoryInTransaction.fromPartial(object.create)
      : undefined;
    message.update = (object.update !== undefined && object.update !== null)
      ? AddCategoryVersionInTransaction.fromPartial(object.update)
      : undefined;
    message.delete = (object.delete !== undefined && object.delete !== null)
      ? DeleteCategoryInTransaction.fromPartial(object.delete)
      : undefined;
    return message;
  },
};

function createBaseCreateCategoryCollectionInTransaction(): CreateCategoryCollectionInTransaction {
  return { metadata: undefined, collection: undefined };
}

export const CreateCategoryCollectionInTransaction: MessageFns<CreateCategoryCollectionInTransaction> = {
  encode(message: CreateCategoryCollectionInTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      CreateMetadataInTransaction.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.collection !== undefined) {
      CategoryCollection.encode(message.collection, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCategoryCollectionInTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCategoryCollectionInTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = CreateMetadataInTransaction.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.collection = CategoryCollection.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCategoryCollectionInTransaction {
    return {
      metadata: isSet(object.metadata) ? CreateMetadataInTransaction.fromJSON(object.metadata) : undefined,
      collection: isSet(object.collection) ? CategoryCollection.fromJSON(object.collection) : undefined,
    };
  },

  toJSON(message: CreateCategoryCollectionInTransaction): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = CreateMetadataInTransaction.toJSON(message.metadata);
    }
    if (message.collection !== undefined) {
      obj.collection = CategoryCollection.toJSON(message.collection);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateCategoryCollectionInTransaction>, I>>(
    base?: I,
  ): CreateCategoryCollectionInTransaction {
    return CreateCategoryCollectionInTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateCategoryCollectionInTransaction>, I>>(
    object: I,
  ): CreateCategoryCollectionInTransaction {
    const message = createBaseCreateCategoryCollectionInTransaction();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? CreateMetadataInTransaction.fromPartial(object.metadata)
      : undefined;
    message.collection = (object.collection !== undefined && object.collection !== null)
      ? CategoryCollection.fromPartial(object.collection)
      : undefined;
    return message;
  },
};

function createBaseAddCategoryCollectionVersionInTransaction(): AddCategoryCollectionVersionInTransaction {
  return { metadata: undefined, collection: undefined, revert: undefined };
}

export const AddCategoryCollectionVersionInTransaction: MessageFns<AddCategoryCollectionVersionInTransaction> = {
  encode(message: AddCategoryCollectionVersionInTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      AddVersionMetadataInTransaction.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.collection !== undefined) {
      CategoryCollection.encode(message.collection, writer.uint32(18).fork()).join();
    }
    if (message.revert !== undefined) {
      RevertProfile.encode(message.revert, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddCategoryCollectionVersionInTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddCategoryCollectionVersionInTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = AddVersionMetadataInTransaction.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.collection = CategoryCollection.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.revert = RevertProfile.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddCategoryCollectionVersionInTransaction {
    return {
      metadata: isSet(object.metadata) ? AddVersionMetadataInTransaction.fromJSON(object.metadata) : undefined,
      collection: isSet(object.collection) ? CategoryCollection.fromJSON(object.collection) : undefined,
      revert: isSet(object.revert) ? RevertProfile.fromJSON(object.revert) : undefined,
    };
  },

  toJSON(message: AddCategoryCollectionVersionInTransaction): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = AddVersionMetadataInTransaction.toJSON(message.metadata);
    }
    if (message.collection !== undefined) {
      obj.collection = CategoryCollection.toJSON(message.collection);
    }
    if (message.revert !== undefined) {
      obj.revert = RevertProfile.toJSON(message.revert);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddCategoryCollectionVersionInTransaction>, I>>(
    base?: I,
  ): AddCategoryCollectionVersionInTransaction {
    return AddCategoryCollectionVersionInTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddCategoryCollectionVersionInTransaction>, I>>(
    object: I,
  ): AddCategoryCollectionVersionInTransaction {
    const message = createBaseAddCategoryCollectionVersionInTransaction();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? AddVersionMetadataInTransaction.fromPartial(object.metadata)
      : undefined;
    message.collection = (object.collection !== undefined && object.collection !== null)
      ? CategoryCollection.fromPartial(object.collection)
      : undefined;
    message.revert = (object.revert !== undefined && object.revert !== null)
      ? RevertProfile.fromPartial(object.revert)
      : undefined;
    return message;
  },
};

function createBaseDeleteCategoryCollectionInTransaction(): DeleteCategoryCollectionInTransaction {
  return { id: "" };
}

export const DeleteCategoryCollectionInTransaction: MessageFns<DeleteCategoryCollectionInTransaction> = {
  encode(message: DeleteCategoryCollectionInTransaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCategoryCollectionInTransaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCategoryCollectionInTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteCategoryCollectionInTransaction {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: DeleteCategoryCollectionInTransaction): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteCategoryCollectionInTransaction>, I>>(
    base?: I,
  ): DeleteCategoryCollectionInTransaction {
    return DeleteCategoryCollectionInTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteCategoryCollectionInTransaction>, I>>(
    object: I,
  ): DeleteCategoryCollectionInTransaction {
    const message = createBaseDeleteCategoryCollectionInTransaction();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseCategoryCollectionChange(): CategoryCollectionChange {
  return { create: undefined, update: undefined, delete: undefined };
}

export const CategoryCollectionChange: MessageFns<CategoryCollectionChange> = {
  encode(message: CategoryCollectionChange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.create !== undefined) {
      CreateCategoryCollectionInTransaction.encode(message.create, writer.uint32(10).fork()).join();
    }
    if (message.update !== undefined) {
      AddCategoryCollectionVersionInTransaction.encode(message.update, writer.uint32(18).fork()).join();
    }
    if (message.delete !== undefined) {
      DeleteCategoryCollectionInTransaction.encode(message.delete, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CategoryCollectionChange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCategoryCollectionChange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.create = CreateCategoryCollectionInTransaction.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.update = AddCategoryCollectionVersionInTransaction.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.delete = DeleteCategoryCollectionInTransaction.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CategoryCollectionChange {
    return {
      create: isSet(object.create) ? CreateCategoryCollectionInTransaction.fromJSON(object.create) : undefined,
      update: isSet(object.update) ? AddCategoryCollectionVersionInTransaction.fromJSON(object.update) : undefined,
      delete: isSet(object.delete) ? DeleteCategoryCollectionInTransaction.fromJSON(object.delete) : undefined,
    };
  },

  toJSON(message: CategoryCollectionChange): unknown {
    const obj: any = {};
    if (message.create !== undefined) {
      obj.create = CreateCategoryCollectionInTransaction.toJSON(message.create);
    }
    if (message.update !== undefined) {
      obj.update = AddCategoryCollectionVersionInTransaction.toJSON(message.update);
    }
    if (message.delete !== undefined) {
      obj.delete = DeleteCategoryCollectionInTransaction.toJSON(message.delete);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CategoryCollectionChange>, I>>(base?: I): CategoryCollectionChange {
    return CategoryCollectionChange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CategoryCollectionChange>, I>>(object: I): CategoryCollectionChange {
    const message = createBaseCategoryCollectionChange();
    message.create = (object.create !== undefined && object.create !== null)
      ? CreateCategoryCollectionInTransaction.fromPartial(object.create)
      : undefined;
    message.update = (object.update !== undefined && object.update !== null)
      ? AddCategoryCollectionVersionInTransaction.fromPartial(object.update)
      : undefined;
    message.delete = (object.delete !== undefined && object.delete !== null)
      ? DeleteCategoryCollectionInTransaction.fromPartial(object.delete)
      : undefined;
    return message;
  },
};

function createBaseApplyPlantProfileTransactionRequest(): ApplyPlantProfileTransactionRequest {
  return { metadata: undefined, categories: [], collections: [] };
}

export const ApplyPlantProfileTransactionRequest: MessageFns<ApplyPlantProfileTransactionRequest> = {
  encode(message: ApplyPlantProfileTransactionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      BaseTransactionMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    for (const v of message.categories) {
      CategoryChange.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.collections) {
      CategoryCollectionChange.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApplyPlantProfileTransactionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApplyPlantProfileTransactionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = BaseTransactionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.categories.push(CategoryChange.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.collections.push(CategoryCollectionChange.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApplyPlantProfileTransactionRequest {
    return {
      metadata: isSet(object.metadata) ? BaseTransactionMetadata.fromJSON(object.metadata) : undefined,
      categories: globalThis.Array.isArray(object?.categories)
        ? object.categories.map((e: any) => CategoryChange.fromJSON(e))
        : [],
      collections: globalThis.Array.isArray(object?.collections)
        ? object.collections.map((e: any) => CategoryCollectionChange.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApplyPlantProfileTransactionRequest): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = BaseTransactionMetadata.toJSON(message.metadata);
    }
    if (message.categories?.length) {
      obj.categories = message.categories.map((e) => CategoryChange.toJSON(e));
    }
    if (message.collections?.length) {
      obj.collections = message.collections.map((e) => CategoryCollectionChange.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApplyPlantProfileTransactionRequest>, I>>(
    base?: I,
  ): ApplyPlantProfileTransactionRequest {
    return ApplyPlantProfileTransactionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApplyPlantProfileTransactionRequest>, I>>(
    object: I,
  ): ApplyPlantProfileTransactionRequest {
    const message = createBaseApplyPlantProfileTransactionRequest();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? BaseTransactionMetadata.fromPartial(object.metadata)
      : undefined;
    message.categories = object.categories?.map((e) => CategoryChange.fromPartial(e)) || [];
    message.collections = object.collections?.map((e) => CategoryCollectionChange.fromPartial(e)) || [];
    return message;
  },
};

function createBaseApplyPlantProfileTransactionResponse(): ApplyPlantProfileTransactionResponse {
  return { categories: [], collections: [] };
}

export const ApplyPlantProfileTransactionResponse: MessageFns<ApplyPlantProfileTransactionResponse> = {
  encode(message: ApplyPlantProfileTransactionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.categories) {
      SavedCategory.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.collections) {
      SavedCategoryCollection.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApplyPlantProfileTransactionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApplyPlantProfileTransactionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.categories.push(SavedCategory.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.collections.push(SavedCategoryCollection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApplyPlantProfileTransactionResponse {
    return {
      categories: globalThis.Array.isArray(object?.categories)
        ? object.categories.map((e: any) => SavedCategory.fromJSON(e))
        : [],
      collections: globalThis.Array.isArray(object?.collections)
        ? object.collections.map((e: any) => SavedCategoryCollection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApplyPlantProfileTransactionResponse): unknown {
    const obj: any = {};
    if (message.categories?.length) {
      obj.categories = message.categories.map((e) => SavedCategory.toJSON(e));
    }
    if (message.collections?.length) {
      obj.collections = message.collections.map((e) => SavedCategoryCollection.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApplyPlantProfileTransactionResponse>, I>>(
    base?: I,
  ): ApplyPlantProfileTransactionResponse {
    return ApplyPlantProfileTransactionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApplyPlantProfileTransactionResponse>, I>>(
    object: I,
  ): ApplyPlantProfileTransactionResponse {
    const message = createBaseApplyPlantProfileTransactionResponse();
    message.categories = object.categories?.map((e) => SavedCategory.fromPartial(e)) || [];
    message.collections = object.collections?.map((e) => SavedCategoryCollection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListCategoryCollectionHistoryRequest(): ListCategoryCollectionHistoryRequest {
  return { id: "", pagination: undefined };
}

export const ListCategoryCollectionHistoryRequest: MessageFns<ListCategoryCollectionHistoryRequest> = {
  encode(message: ListCategoryCollectionHistoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCategoryCollectionHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCategoryCollectionHistoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCategoryCollectionHistoryRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: ListCategoryCollectionHistoryRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCategoryCollectionHistoryRequest>, I>>(
    base?: I,
  ): ListCategoryCollectionHistoryRequest {
    return ListCategoryCollectionHistoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCategoryCollectionHistoryRequest>, I>>(
    object: I,
  ): ListCategoryCollectionHistoryRequest {
    const message = createBaseListCategoryCollectionHistoryRequest();
    message.id = object.id ?? "";
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseListCategoryCollectionHistoryResponse(): ListCategoryCollectionHistoryResponse {
  return { pagination: undefined, versions: [] };
}

export const ListCategoryCollectionHistoryResponse: MessageFns<ListCategoryCollectionHistoryResponse> = {
  encode(message: ListCategoryCollectionHistoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(10).fork()).join();
    }
    for (const v of message.versions) {
      SavedVersionMetadata.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCategoryCollectionHistoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCategoryCollectionHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.versions.push(SavedVersionMetadata.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCategoryCollectionHistoryResponse {
    return {
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
      versions: globalThis.Array.isArray(object?.versions)
        ? object.versions.map((e: any) => SavedVersionMetadata.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListCategoryCollectionHistoryResponse): unknown {
    const obj: any = {};
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    if (message.versions?.length) {
      obj.versions = message.versions.map((e) => SavedVersionMetadata.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCategoryCollectionHistoryResponse>, I>>(
    base?: I,
  ): ListCategoryCollectionHistoryResponse {
    return ListCategoryCollectionHistoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCategoryCollectionHistoryResponse>, I>>(
    object: I,
  ): ListCategoryCollectionHistoryResponse {
    const message = createBaseListCategoryCollectionHistoryResponse();
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    message.versions = object.versions?.map((e) => SavedVersionMetadata.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListCategoryHistoryRequest(): ListCategoryHistoryRequest {
  return { id: "", pagination: undefined };
}

export const ListCategoryHistoryRequest: MessageFns<ListCategoryHistoryRequest> = {
  encode(message: ListCategoryHistoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCategoryHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCategoryHistoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCategoryHistoryRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: ListCategoryHistoryRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCategoryHistoryRequest>, I>>(base?: I): ListCategoryHistoryRequest {
    return ListCategoryHistoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCategoryHistoryRequest>, I>>(object: I): ListCategoryHistoryRequest {
    const message = createBaseListCategoryHistoryRequest();
    message.id = object.id ?? "";
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseListCategoryHistoryResponse(): ListCategoryHistoryResponse {
  return { pagination: undefined, versions: [] };
}

export const ListCategoryHistoryResponse: MessageFns<ListCategoryHistoryResponse> = {
  encode(message: ListCategoryHistoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(10).fork()).join();
    }
    for (const v of message.versions) {
      SavedVersionMetadata.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCategoryHistoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCategoryHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.versions.push(SavedVersionMetadata.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCategoryHistoryResponse {
    return {
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
      versions: globalThis.Array.isArray(object?.versions)
        ? object.versions.map((e: any) => SavedVersionMetadata.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListCategoryHistoryResponse): unknown {
    const obj: any = {};
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    if (message.versions?.length) {
      obj.versions = message.versions.map((e) => SavedVersionMetadata.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCategoryHistoryResponse>, I>>(base?: I): ListCategoryHistoryResponse {
    return ListCategoryHistoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCategoryHistoryResponse>, I>>(object: I): ListCategoryHistoryResponse {
    const message = createBaseListCategoryHistoryResponse();
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    message.versions = object.versions?.map((e) => SavedVersionMetadata.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetPlantProfileVersionRequest(): GetPlantProfileVersionRequest {
  return { id: "", versionId: "" };
}

export const GetPlantProfileVersionRequest: MessageFns<GetPlantProfileVersionRequest> = {
  encode(message: GetPlantProfileVersionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.versionId !== "") {
      writer.uint32(18).string(message.versionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPlantProfileVersionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPlantProfileVersionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPlantProfileVersionRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : "",
    };
  },

  toJSON(message: GetPlantProfileVersionRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.versionId !== "") {
      obj.versionId = message.versionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPlantProfileVersionRequest>, I>>(base?: I): GetPlantProfileVersionRequest {
    return GetPlantProfileVersionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPlantProfileVersionRequest>, I>>(
    object: I,
  ): GetPlantProfileVersionRequest {
    const message = createBaseGetPlantProfileVersionRequest();
    message.id = object.id ?? "";
    message.versionId = object.versionId ?? "";
    return message;
  },
};

function createBaseGetCategoryVersionRequest(): GetCategoryVersionRequest {
  return { id: "", versionId: "" };
}

export const GetCategoryVersionRequest: MessageFns<GetCategoryVersionRequest> = {
  encode(message: GetCategoryVersionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.versionId !== "") {
      writer.uint32(18).string(message.versionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryVersionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryVersionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryVersionRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : "",
    };
  },

  toJSON(message: GetCategoryVersionRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.versionId !== "") {
      obj.versionId = message.versionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryVersionRequest>, I>>(base?: I): GetCategoryVersionRequest {
    return GetCategoryVersionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryVersionRequest>, I>>(object: I): GetCategoryVersionRequest {
    const message = createBaseGetCategoryVersionRequest();
    message.id = object.id ?? "";
    message.versionId = object.versionId ?? "";
    return message;
  },
};

function createBaseGetCategoriesRequest(): GetCategoriesRequest {
  return { categories: [] };
}

export const GetCategoriesRequest: MessageFns<GetCategoriesRequest> = {
  encode(message: GetCategoriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.categories) {
      GetCategoriesRequest_IdPair.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.categories.push(GetCategoriesRequest_IdPair.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoriesRequest {
    return {
      categories: globalThis.Array.isArray(object?.categories)
        ? object.categories.map((e: any) => GetCategoriesRequest_IdPair.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCategoriesRequest): unknown {
    const obj: any = {};
    if (message.categories?.length) {
      obj.categories = message.categories.map((e) => GetCategoriesRequest_IdPair.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoriesRequest>, I>>(base?: I): GetCategoriesRequest {
    return GetCategoriesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoriesRequest>, I>>(object: I): GetCategoriesRequest {
    const message = createBaseGetCategoriesRequest();
    message.categories = object.categories?.map((e) => GetCategoriesRequest_IdPair.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCategoriesRequest_IdPair(): GetCategoriesRequest_IdPair {
  return { id: "", versionId: undefined };
}

export const GetCategoriesRequest_IdPair: MessageFns<GetCategoriesRequest_IdPair> = {
  encode(message: GetCategoriesRequest_IdPair, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.versionId !== undefined) {
      writer.uint32(18).string(message.versionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoriesRequest_IdPair {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoriesRequest_IdPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoriesRequest_IdPair {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : undefined,
    };
  },

  toJSON(message: GetCategoriesRequest_IdPair): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.versionId !== undefined) {
      obj.versionId = message.versionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoriesRequest_IdPair>, I>>(base?: I): GetCategoriesRequest_IdPair {
    return GetCategoriesRequest_IdPair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoriesRequest_IdPair>, I>>(object: I): GetCategoriesRequest_IdPair {
    const message = createBaseGetCategoriesRequest_IdPair();
    message.id = object.id ?? "";
    message.versionId = object.versionId ?? undefined;
    return message;
  },
};

function createBaseGetCategoriesResponse(): GetCategoriesResponse {
  return { categories: {} };
}

export const GetCategoriesResponse: MessageFns<GetCategoriesResponse> = {
  encode(message: GetCategoriesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.categories).forEach(([key, value]: [string, SavedCategory]) => {
      GetCategoriesResponse_CategoriesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoriesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = GetCategoriesResponse_CategoriesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.categories[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoriesResponse {
    return {
      categories: isObject(object.categories)
        ? (globalThis.Object.entries(object.categories) as [string, any][]).reduce(
          (acc: { [key: string]: SavedCategory }, [key, value]: [string, any]) => {
            acc[key] = SavedCategory.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: GetCategoriesResponse): unknown {
    const obj: any = {};
    if (message.categories) {
      const entries = globalThis.Object.entries(message.categories) as [string, SavedCategory][];
      if (entries.length > 0) {
        obj.categories = {};
        entries.forEach(([k, v]) => {
          obj.categories[k] = SavedCategory.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoriesResponse>, I>>(base?: I): GetCategoriesResponse {
    return GetCategoriesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoriesResponse>, I>>(object: I): GetCategoriesResponse {
    const message = createBaseGetCategoriesResponse();
    message.categories = (globalThis.Object.entries(object.categories ?? {}) as [string, SavedCategory][]).reduce(
      (acc: { [key: string]: SavedCategory }, [key, value]: [string, SavedCategory]) => {
        if (value !== undefined) {
          acc[key] = SavedCategory.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseGetCategoriesResponse_CategoriesEntry(): GetCategoriesResponse_CategoriesEntry {
  return { key: "", value: undefined };
}

export const GetCategoriesResponse_CategoriesEntry: MessageFns<GetCategoriesResponse_CategoriesEntry> = {
  encode(message: GetCategoriesResponse_CategoriesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      SavedCategory.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoriesResponse_CategoriesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoriesResponse_CategoriesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = SavedCategory.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoriesResponse_CategoriesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? SavedCategory.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: GetCategoriesResponse_CategoriesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = SavedCategory.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoriesResponse_CategoriesEntry>, I>>(
    base?: I,
  ): GetCategoriesResponse_CategoriesEntry {
    return GetCategoriesResponse_CategoriesEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoriesResponse_CategoriesEntry>, I>>(
    object: I,
  ): GetCategoriesResponse_CategoriesEntry {
    const message = createBaseGetCategoriesResponse_CategoriesEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? SavedCategory.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseGetCategoryIdsForCategoryCollectionsRequest(): GetCategoryIdsForCategoryCollectionsRequest {
  return { collections: [] };
}

export const GetCategoryIdsForCategoryCollectionsRequest: MessageFns<GetCategoryIdsForCategoryCollectionsRequest> = {
  encode(
    message: GetCategoryIdsForCategoryCollectionsRequest,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    for (const v of message.collections) {
      GetCategoryIdsForCategoryCollectionsRequest_IdPair.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryIdsForCategoryCollectionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryIdsForCategoryCollectionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.collections.push(GetCategoryIdsForCategoryCollectionsRequest_IdPair.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryIdsForCategoryCollectionsRequest {
    return {
      collections: globalThis.Array.isArray(object?.collections)
        ? object.collections.map((e: any) => GetCategoryIdsForCategoryCollectionsRequest_IdPair.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCategoryIdsForCategoryCollectionsRequest): unknown {
    const obj: any = {};
    if (message.collections?.length) {
      obj.collections = message.collections.map((e) => GetCategoryIdsForCategoryCollectionsRequest_IdPair.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsRequest>, I>>(
    base?: I,
  ): GetCategoryIdsForCategoryCollectionsRequest {
    return GetCategoryIdsForCategoryCollectionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsRequest>, I>>(
    object: I,
  ): GetCategoryIdsForCategoryCollectionsRequest {
    const message = createBaseGetCategoryIdsForCategoryCollectionsRequest();
    message.collections =
      object.collections?.map((e) => GetCategoryIdsForCategoryCollectionsRequest_IdPair.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCategoryIdsForCategoryCollectionsRequest_IdPair(): GetCategoryIdsForCategoryCollectionsRequest_IdPair {
  return { id: "", versionId: undefined };
}

export const GetCategoryIdsForCategoryCollectionsRequest_IdPair: MessageFns<
  GetCategoryIdsForCategoryCollectionsRequest_IdPair
> = {
  encode(
    message: GetCategoryIdsForCategoryCollectionsRequest_IdPair,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.versionId !== undefined) {
      writer.uint32(18).string(message.versionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryIdsForCategoryCollectionsRequest_IdPair {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryIdsForCategoryCollectionsRequest_IdPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryIdsForCategoryCollectionsRequest_IdPair {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : undefined,
    };
  },

  toJSON(message: GetCategoryIdsForCategoryCollectionsRequest_IdPair): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.versionId !== undefined) {
      obj.versionId = message.versionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsRequest_IdPair>, I>>(
    base?: I,
  ): GetCategoryIdsForCategoryCollectionsRequest_IdPair {
    return GetCategoryIdsForCategoryCollectionsRequest_IdPair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsRequest_IdPair>, I>>(
    object: I,
  ): GetCategoryIdsForCategoryCollectionsRequest_IdPair {
    const message = createBaseGetCategoryIdsForCategoryCollectionsRequest_IdPair();
    message.id = object.id ?? "";
    message.versionId = object.versionId ?? undefined;
    return message;
  },
};

function createBaseGetCategoryIdsForCategoryCollectionsResponse(): GetCategoryIdsForCategoryCollectionsResponse {
  return { collections: {} };
}

export const GetCategoryIdsForCategoryCollectionsResponse: MessageFns<GetCategoryIdsForCategoryCollectionsResponse> = {
  encode(
    message: GetCategoryIdsForCategoryCollectionsResponse,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    globalThis.Object.entries(message.collections).forEach(
      ([key, value]: [string, GetCategoryIdsForCategoryCollectionsResponse_Versions]) => {
        GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry.encode(
          { key: key as any, value },
          writer.uint32(10).fork(),
        ).join();
      },
    );
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryIdsForCategoryCollectionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryIdsForCategoryCollectionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.collections[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryIdsForCategoryCollectionsResponse {
    return {
      collections: isObject(object.collections)
        ? (globalThis.Object.entries(object.collections) as [string, any][]).reduce(
          (
            acc: { [key: string]: GetCategoryIdsForCategoryCollectionsResponse_Versions },
            [key, value]: [string, any],
          ) => {
            acc[key] = GetCategoryIdsForCategoryCollectionsResponse_Versions.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: GetCategoryIdsForCategoryCollectionsResponse): unknown {
    const obj: any = {};
    if (message.collections) {
      const entries = globalThis.Object.entries(message.collections) as [
        string,
        GetCategoryIdsForCategoryCollectionsResponse_Versions,
      ][];
      if (entries.length > 0) {
        obj.collections = {};
        entries.forEach(([k, v]) => {
          obj.collections[k] = GetCategoryIdsForCategoryCollectionsResponse_Versions.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsResponse>, I>>(
    base?: I,
  ): GetCategoryIdsForCategoryCollectionsResponse {
    return GetCategoryIdsForCategoryCollectionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsResponse>, I>>(
    object: I,
  ): GetCategoryIdsForCategoryCollectionsResponse {
    const message = createBaseGetCategoryIdsForCategoryCollectionsResponse();
    message.collections =
      (globalThis.Object.entries(object.collections ?? {}) as [
        string,
        GetCategoryIdsForCategoryCollectionsResponse_Versions,
      ][]).reduce(
        (
          acc: { [key: string]: GetCategoryIdsForCategoryCollectionsResponse_Versions },
          [key, value]: [string, GetCategoryIdsForCategoryCollectionsResponse_Versions],
        ) => {
          if (value !== undefined) {
            acc[key] = GetCategoryIdsForCategoryCollectionsResponse_Versions.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    return message;
  },
};

function createBaseGetCategoryIdsForCategoryCollectionsResponse_IdPair(): GetCategoryIdsForCategoryCollectionsResponse_IdPair {
  return { id: "", versionId: "" };
}

export const GetCategoryIdsForCategoryCollectionsResponse_IdPair: MessageFns<
  GetCategoryIdsForCategoryCollectionsResponse_IdPair
> = {
  encode(
    message: GetCategoryIdsForCategoryCollectionsResponse_IdPair,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.versionId !== "") {
      writer.uint32(18).string(message.versionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryIdsForCategoryCollectionsResponse_IdPair {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryIdsForCategoryCollectionsResponse_IdPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryIdsForCategoryCollectionsResponse_IdPair {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : "",
    };
  },

  toJSON(message: GetCategoryIdsForCategoryCollectionsResponse_IdPair): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.versionId !== "") {
      obj.versionId = message.versionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsResponse_IdPair>, I>>(
    base?: I,
  ): GetCategoryIdsForCategoryCollectionsResponse_IdPair {
    return GetCategoryIdsForCategoryCollectionsResponse_IdPair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsResponse_IdPair>, I>>(
    object: I,
  ): GetCategoryIdsForCategoryCollectionsResponse_IdPair {
    const message = createBaseGetCategoryIdsForCategoryCollectionsResponse_IdPair();
    message.id = object.id ?? "";
    message.versionId = object.versionId ?? "";
    return message;
  },
};

function createBaseGetCategoryIdsForCategoryCollectionsResponse_IdPairs(): GetCategoryIdsForCategoryCollectionsResponse_IdPairs {
  return { categoryIds: [] };
}

export const GetCategoryIdsForCategoryCollectionsResponse_IdPairs: MessageFns<
  GetCategoryIdsForCategoryCollectionsResponse_IdPairs
> = {
  encode(
    message: GetCategoryIdsForCategoryCollectionsResponse_IdPairs,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    for (const v of message.categoryIds) {
      GetCategoryIdsForCategoryCollectionsResponse_IdPair.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryIdsForCategoryCollectionsResponse_IdPairs {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryIdsForCategoryCollectionsResponse_IdPairs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.categoryIds.push(GetCategoryIdsForCategoryCollectionsResponse_IdPair.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryIdsForCategoryCollectionsResponse_IdPairs {
    return {
      categoryIds: globalThis.Array.isArray(object?.categoryIds)
        ? object.categoryIds.map((e: any) => GetCategoryIdsForCategoryCollectionsResponse_IdPair.fromJSON(e))
        : globalThis.Array.isArray(object?.category_ids)
        ? object.category_ids.map((e: any) => GetCategoryIdsForCategoryCollectionsResponse_IdPair.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCategoryIdsForCategoryCollectionsResponse_IdPairs): unknown {
    const obj: any = {};
    if (message.categoryIds?.length) {
      obj.categoryIds = message.categoryIds.map((e) => GetCategoryIdsForCategoryCollectionsResponse_IdPair.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsResponse_IdPairs>, I>>(
    base?: I,
  ): GetCategoryIdsForCategoryCollectionsResponse_IdPairs {
    return GetCategoryIdsForCategoryCollectionsResponse_IdPairs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsResponse_IdPairs>, I>>(
    object: I,
  ): GetCategoryIdsForCategoryCollectionsResponse_IdPairs {
    const message = createBaseGetCategoryIdsForCategoryCollectionsResponse_IdPairs();
    message.categoryIds =
      object.categoryIds?.map((e) => GetCategoryIdsForCategoryCollectionsResponse_IdPair.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCategoryIdsForCategoryCollectionsResponse_Versions(): GetCategoryIdsForCategoryCollectionsResponse_Versions {
  return { versions: {} };
}

export const GetCategoryIdsForCategoryCollectionsResponse_Versions: MessageFns<
  GetCategoryIdsForCategoryCollectionsResponse_Versions
> = {
  encode(
    message: GetCategoryIdsForCategoryCollectionsResponse_Versions,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    globalThis.Object.entries(message.versions).forEach(
      ([key, value]: [string, GetCategoryIdsForCategoryCollectionsResponse_IdPairs]) => {
        GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry.encode(
          { key: key as any, value },
          writer.uint32(10).fork(),
        ).join();
      },
    );
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryIdsForCategoryCollectionsResponse_Versions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryIdsForCategoryCollectionsResponse_Versions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry.decode(
            reader,
            reader.uint32(),
          );
          if (entry1.value !== undefined) {
            message.versions[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryIdsForCategoryCollectionsResponse_Versions {
    return {
      versions: isObject(object.versions)
        ? (globalThis.Object.entries(object.versions) as [string, any][]).reduce(
          (
            acc: { [key: string]: GetCategoryIdsForCategoryCollectionsResponse_IdPairs },
            [key, value]: [string, any],
          ) => {
            acc[key] = GetCategoryIdsForCategoryCollectionsResponse_IdPairs.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: GetCategoryIdsForCategoryCollectionsResponse_Versions): unknown {
    const obj: any = {};
    if (message.versions) {
      const entries = globalThis.Object.entries(message.versions) as [
        string,
        GetCategoryIdsForCategoryCollectionsResponse_IdPairs,
      ][];
      if (entries.length > 0) {
        obj.versions = {};
        entries.forEach(([k, v]) => {
          obj.versions[k] = GetCategoryIdsForCategoryCollectionsResponse_IdPairs.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsResponse_Versions>, I>>(
    base?: I,
  ): GetCategoryIdsForCategoryCollectionsResponse_Versions {
    return GetCategoryIdsForCategoryCollectionsResponse_Versions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsResponse_Versions>, I>>(
    object: I,
  ): GetCategoryIdsForCategoryCollectionsResponse_Versions {
    const message = createBaseGetCategoryIdsForCategoryCollectionsResponse_Versions();
    message.versions =
      (globalThis.Object.entries(object.versions ?? {}) as [
        string,
        GetCategoryIdsForCategoryCollectionsResponse_IdPairs,
      ][]).reduce(
        (
          acc: { [key: string]: GetCategoryIdsForCategoryCollectionsResponse_IdPairs },
          [key, value]: [string, GetCategoryIdsForCategoryCollectionsResponse_IdPairs],
        ) => {
          if (value !== undefined) {
            acc[key] = GetCategoryIdsForCategoryCollectionsResponse_IdPairs.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    return message;
  },
};

function createBaseGetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry(): GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry {
  return { key: "", value: undefined };
}

export const GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry: MessageFns<
  GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry
> = {
  encode(
    message: GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      GetCategoryIdsForCategoryCollectionsResponse_IdPairs.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = GetCategoryIdsForCategoryCollectionsResponse_IdPairs.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value)
        ? GetCategoryIdsForCategoryCollectionsResponse_IdPairs.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = GetCategoryIdsForCategoryCollectionsResponse_IdPairs.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry>, I>>(
    base?: I,
  ): GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry {
    return GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry>, I>>(
    object: I,
  ): GetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry {
    const message = createBaseGetCategoryIdsForCategoryCollectionsResponse_Versions_VersionsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? GetCategoryIdsForCategoryCollectionsResponse_IdPairs.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseGetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry(): GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry {
  return { key: "", value: undefined };
}

export const GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry: MessageFns<
  GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry
> = {
  encode(
    message: GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      GetCategoryIdsForCategoryCollectionsResponse_Versions.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(
    input: BinaryReader | Uint8Array,
    length?: number,
  ): GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = GetCategoryIdsForCategoryCollectionsResponse_Versions.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value)
        ? GetCategoryIdsForCategoryCollectionsResponse_Versions.fromJSON(object.value)
        : undefined,
    };
  },

  toJSON(message: GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = GetCategoryIdsForCategoryCollectionsResponse_Versions.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry>, I>>(
    base?: I,
  ): GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry {
    return GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry>, I>>(
    object: I,
  ): GetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry {
    const message = createBaseGetCategoryIdsForCategoryCollectionsResponse_CollectionsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? GetCategoryIdsForCategoryCollectionsResponse_Versions.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseGetCategoryCollectionsRequest(): GetCategoryCollectionsRequest {
  return { collections: [] };
}

export const GetCategoryCollectionsRequest: MessageFns<GetCategoryCollectionsRequest> = {
  encode(message: GetCategoryCollectionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.collections) {
      GetCategoryCollectionsRequest_IdPair.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryCollectionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryCollectionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.collections.push(GetCategoryCollectionsRequest_IdPair.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryCollectionsRequest {
    return {
      collections: globalThis.Array.isArray(object?.collections)
        ? object.collections.map((e: any) => GetCategoryCollectionsRequest_IdPair.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCategoryCollectionsRequest): unknown {
    const obj: any = {};
    if (message.collections?.length) {
      obj.collections = message.collections.map((e) => GetCategoryCollectionsRequest_IdPair.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryCollectionsRequest>, I>>(base?: I): GetCategoryCollectionsRequest {
    return GetCategoryCollectionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryCollectionsRequest>, I>>(
    object: I,
  ): GetCategoryCollectionsRequest {
    const message = createBaseGetCategoryCollectionsRequest();
    message.collections = object.collections?.map((e) => GetCategoryCollectionsRequest_IdPair.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCategoryCollectionsRequest_IdPair(): GetCategoryCollectionsRequest_IdPair {
  return { id: "", versionId: undefined };
}

export const GetCategoryCollectionsRequest_IdPair: MessageFns<GetCategoryCollectionsRequest_IdPair> = {
  encode(message: GetCategoryCollectionsRequest_IdPair, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.versionId !== undefined) {
      writer.uint32(18).string(message.versionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryCollectionsRequest_IdPair {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryCollectionsRequest_IdPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.versionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryCollectionsRequest_IdPair {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      versionId: isSet(object.versionId)
        ? globalThis.String(object.versionId)
        : isSet(object.version_id)
        ? globalThis.String(object.version_id)
        : undefined,
    };
  },

  toJSON(message: GetCategoryCollectionsRequest_IdPair): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.versionId !== undefined) {
      obj.versionId = message.versionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryCollectionsRequest_IdPair>, I>>(
    base?: I,
  ): GetCategoryCollectionsRequest_IdPair {
    return GetCategoryCollectionsRequest_IdPair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryCollectionsRequest_IdPair>, I>>(
    object: I,
  ): GetCategoryCollectionsRequest_IdPair {
    const message = createBaseGetCategoryCollectionsRequest_IdPair();
    message.id = object.id ?? "";
    message.versionId = object.versionId ?? undefined;
    return message;
  },
};

function createBaseGetCategoryCollectionsResponse(): GetCategoryCollectionsResponse {
  return { collections: {} };
}

export const GetCategoryCollectionsResponse: MessageFns<GetCategoryCollectionsResponse> = {
  encode(message: GetCategoryCollectionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.collections).forEach(([key, value]: [string, SavedCategoryCollection]) => {
      GetCategoryCollectionsResponse_CollectionsEntry.encode({ key: key as any, value }, writer.uint32(10).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryCollectionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryCollectionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = GetCategoryCollectionsResponse_CollectionsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.collections[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryCollectionsResponse {
    return {
      collections: isObject(object.collections)
        ? (globalThis.Object.entries(object.collections) as [string, any][]).reduce(
          (acc: { [key: string]: SavedCategoryCollection }, [key, value]: [string, any]) => {
            acc[key] = SavedCategoryCollection.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: GetCategoryCollectionsResponse): unknown {
    const obj: any = {};
    if (message.collections) {
      const entries = globalThis.Object.entries(message.collections) as [string, SavedCategoryCollection][];
      if (entries.length > 0) {
        obj.collections = {};
        entries.forEach(([k, v]) => {
          obj.collections[k] = SavedCategoryCollection.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryCollectionsResponse>, I>>(base?: I): GetCategoryCollectionsResponse {
    return GetCategoryCollectionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryCollectionsResponse>, I>>(
    object: I,
  ): GetCategoryCollectionsResponse {
    const message = createBaseGetCategoryCollectionsResponse();
    message.collections = (globalThis.Object.entries(object.collections ?? {}) as [string, SavedCategoryCollection][])
      .reduce((acc: { [key: string]: SavedCategoryCollection }, [key, value]: [string, SavedCategoryCollection]) => {
        if (value !== undefined) {
          acc[key] = SavedCategoryCollection.fromPartial(value);
        }
        return acc;
      }, {});
    return message;
  },
};

function createBaseGetCategoryCollectionsResponse_CollectionsEntry(): GetCategoryCollectionsResponse_CollectionsEntry {
  return { key: "", value: undefined };
}

export const GetCategoryCollectionsResponse_CollectionsEntry: MessageFns<
  GetCategoryCollectionsResponse_CollectionsEntry
> = {
  encode(
    message: GetCategoryCollectionsResponse_CollectionsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      SavedCategoryCollection.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCategoryCollectionsResponse_CollectionsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCategoryCollectionsResponse_CollectionsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = SavedCategoryCollection.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCategoryCollectionsResponse_CollectionsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? SavedCategoryCollection.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: GetCategoryCollectionsResponse_CollectionsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = SavedCategoryCollection.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCategoryCollectionsResponse_CollectionsEntry>, I>>(
    base?: I,
  ): GetCategoryCollectionsResponse_CollectionsEntry {
    return GetCategoryCollectionsResponse_CollectionsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCategoryCollectionsResponse_CollectionsEntry>, I>>(
    object: I,
  ): GetCategoryCollectionsResponse_CollectionsEntry {
    const message = createBaseGetCategoryCollectionsResponse_CollectionsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? SavedCategoryCollection.fromPartial(object.value)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
